/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const deleteUsers = /* GraphQL */ `
  mutation DeleteUsers(
    $input: DeleteUsersInput!
    $condition: ModelUsersConditionInput
  ) {
    deleteUsers(input: $input, condition: $condition) {
      id
      companyId
      companyContactPersonUserId
      country
      contactPersonUserId
      email
      baseType
      imageUrl
      lastLogin
      firstName
      lastName
      language
      mobil
      phone
      position
      pushNotifications
      notifications
      forms
      productTourStatus
      roleId
      settings
      twoFactorEnabled
      createdAt
      updatedAt
      countryCode
    }
  }
`;
export const deleteProductRequestsItems = /* GraphQL */ `
  mutation DeleteProductRequestsItems(
    $input: DeleteProductRequestsItemsInput!
    $condition: ModelProductRequestsItemsConditionInput
  ) {
    deleteProductRequestsItems(input: $input, condition: $condition) {
      id
      createdAt
      productRequestsID
      itemsID
      selectedPriceOffersId
      priceOffer
      selectedPriceOfferCalculation
      productionTime
      deliveryType
      quantity
      calculationTargetPrice
      targetPrice
      cbam
      margin
      excludeAdditionalCosts
      additionalCosts
      containerSize
      transportationType
      airFreightCostsPerKilo
      transportCostWarehouseToCustomer
      workingCosts
      tiersId
      updatedAt
    }
  }
`;
export const createQualityReportTemplates = /* GraphQL */ `
  mutation CreateQualityReportTemplates(
    $input: CreateQualityReportTemplatesInput!
    $condition: ModelQualityReportTemplatesConditionInput
  ) {
    createQualityReportTemplates(input: $input, condition: $condition) {
      id
      itemsID
      name
      primary
      categories
      createdAt
      updatedAt
    }
  }
`;
export const updateQualityReportTemplates = /* GraphQL */ `
  mutation UpdateQualityReportTemplates(
    $input: UpdateQualityReportTemplatesInput!
    $condition: ModelQualityReportTemplatesConditionInput
  ) {
    updateQualityReportTemplates(input: $input, condition: $condition) {
      id
      itemsID
      name
      primary
      categories
      createdAt
      updatedAt
    }
  }
`;
export const deleteQualityReportTemplates = /* GraphQL */ `
  mutation DeleteQualityReportTemplates(
    $input: DeleteQualityReportTemplatesInput!
    $condition: ModelQualityReportTemplatesConditionInput
  ) {
    deleteQualityReportTemplates(input: $input, condition: $condition) {
      id
      itemsID
      name
      primary
      categories
      createdAt
      updatedAt
    }
  }
`;
export const createEmailTemplates = /* GraphQL */ `
  mutation CreateEmailTemplates(
    $input: CreateEmailTemplatesInput!
    $condition: ModelEmailTemplatesConditionInput
  ) {
    createEmailTemplates(input: $input, condition: $condition) {
      id
      createdBy
      sharedBase
      sharedGroups
      adminGroups
      type
      isPrimary
      name
      subject
      body
      createdAt
      updatedAt
    }
  }
`;
export const updateEmailTemplates = /* GraphQL */ `
  mutation UpdateEmailTemplates(
    $input: UpdateEmailTemplatesInput!
    $condition: ModelEmailTemplatesConditionInput
  ) {
    updateEmailTemplates(input: $input, condition: $condition) {
      id
      createdBy
      sharedBase
      sharedGroups
      adminGroups
      type
      isPrimary
      name
      subject
      body
      createdAt
      updatedAt
    }
  }
`;
export const deleteEmailTemplates = /* GraphQL */ `
  mutation DeleteEmailTemplates(
    $input: DeleteEmailTemplatesInput!
    $condition: ModelEmailTemplatesConditionInput
  ) {
    deleteEmailTemplates(input: $input, condition: $condition) {
      id
      createdBy
      sharedBase
      sharedGroups
      adminGroups
      type
      isPrimary
      name
      subject
      body
      createdAt
      updatedAt
    }
  }
`;
export const updateEmailTrackingBlocklist = /* GraphQL */ `
  mutation UpdateEmailTrackingBlocklist(
    $input: UpdateEmailTrackingBlocklistInput!
    $condition: ModelEmailTrackingBlocklistConditionInput
  ) {
    updateEmailTrackingBlocklist(input: $input, condition: $condition) {
      id
      createdBy
      sharedBase
      sharedGroups
      adminGroups
      patternType
      pattern
      note
      createdAt
      updatedAt
    }
  }
`;
export const deleteEmailTrackingBlocklist = /* GraphQL */ `
  mutation DeleteEmailTrackingBlocklist(
    $input: DeleteEmailTrackingBlocklistInput!
    $condition: ModelEmailTrackingBlocklistConditionInput
  ) {
    deleteEmailTrackingBlocklist(input: $input, condition: $condition) {
      id
      createdBy
      sharedBase
      sharedGroups
      adminGroups
      patternType
      pattern
      note
      createdAt
      updatedAt
    }
  }
`;
export const createSearchTokens = /* GraphQL */ `
  mutation CreateSearchTokens(
    $input: CreateSearchTokensInput!
    $condition: ModelSearchTokensConditionInput
  ) {
    createSearchTokens(input: $input, condition: $condition) {
      id
      collectionName
      objectID
      word
      objectType
      label
      number
      permissionType
      permissionKey
      countries
      userIds
      createdAt
      updatedAt
    }
  }
`;
export const updateSearchTokens = /* GraphQL */ `
  mutation UpdateSearchTokens(
    $input: UpdateSearchTokensInput!
    $condition: ModelSearchTokensConditionInput
  ) {
    updateSearchTokens(input: $input, condition: $condition) {
      id
      collectionName
      objectID
      word
      objectType
      label
      number
      permissionType
      permissionKey
      countries
      userIds
      createdAt
      updatedAt
    }
  }
`;
export const deleteSearchTokens = /* GraphQL */ `
  mutation DeleteSearchTokens(
    $input: DeleteSearchTokensInput!
    $condition: ModelSearchTokensConditionInput
  ) {
    deleteSearchTokens(input: $input, condition: $condition) {
      id
      collectionName
      objectID
      word
      objectType
      label
      number
      permissionType
      permissionKey
      countries
      userIds
      createdAt
      updatedAt
    }
  }
`;
export const createCompanies = /* GraphQL */ `
  mutation CreateCompanies(
    $input: CreateCompaniesInput!
    $condition: ModelCompaniesConditionInput
  ) {
    createCompanies(input: $input, condition: $condition) {
      id
      contactPersonUserId
      createdAt
      number
      externalNumber
      name
      merge
      nameSearch
      type
      googleId
      size
      itemsID
      standardPaymentConditions
      paymentConditions
      standardDeliveryConditions
      standardVat
      countryCode
      closestPortUNCode
      websiteUrl
      vatNumber
      hubspotCompanyId
      leadfeederId
      duplicateCheck
      possibleDuplicates
      potential
      baseType
      exportCompanyId
      exporter
      initialSetup
      productionCountryCode
      preferredCurrency
      communicationLanguage
      foundingDate
      level
      abcCategory
      phone
      description
      industry
      carrierCode
      linkedinUrl
      additionalDomains
      hubspotType
      doNotContact
      hubspotRaw
      leadShare
      cascadeAssignedTasks
      openTaskCount
      lastContactAt
      activityCount
      aiSummary
      updatedAt
    }
  }
`;
export const updateCompanies = /* GraphQL */ `
  mutation UpdateCompanies(
    $input: UpdateCompaniesInput!
    $condition: ModelCompaniesConditionInput
  ) {
    updateCompanies(input: $input, condition: $condition) {
      id
      contactPersonUserId
      createdAt
      number
      externalNumber
      name
      merge
      nameSearch
      type
      googleId
      size
      itemsID
      standardPaymentConditions
      paymentConditions
      standardDeliveryConditions
      standardVat
      countryCode
      closestPortUNCode
      websiteUrl
      vatNumber
      hubspotCompanyId
      leadfeederId
      duplicateCheck
      possibleDuplicates
      potential
      baseType
      exportCompanyId
      exporter
      initialSetup
      productionCountryCode
      preferredCurrency
      communicationLanguage
      foundingDate
      level
      abcCategory
      phone
      description
      industry
      carrierCode
      linkedinUrl
      additionalDomains
      hubspotType
      doNotContact
      hubspotRaw
      leadShare
      cascadeAssignedTasks
      openTaskCount
      lastContactAt
      activityCount
      aiSummary
      updatedAt
    }
  }
`;
export const deleteCompanies = /* GraphQL */ `
  mutation DeleteCompanies(
    $input: DeleteCompaniesInput!
    $condition: ModelCompaniesConditionInput
  ) {
    deleteCompanies(input: $input, condition: $condition) {
      id
      contactPersonUserId
      createdAt
      number
      externalNumber
      name
      merge
      nameSearch
      type
      googleId
      size
      itemsID
      standardPaymentConditions
      paymentConditions
      standardDeliveryConditions
      standardVat
      countryCode
      closestPortUNCode
      websiteUrl
      vatNumber
      hubspotCompanyId
      leadfeederId
      duplicateCheck
      possibleDuplicates
      potential
      baseType
      exportCompanyId
      exporter
      initialSetup
      productionCountryCode
      preferredCurrency
      communicationLanguage
      foundingDate
      level
      abcCategory
      phone
      description
      industry
      carrierCode
      linkedinUrl
      additionalDomains
      hubspotType
      doNotContact
      hubspotRaw
      leadShare
      cascadeAssignedTasks
      openTaskCount
      lastContactAt
      activityCount
      aiSummary
      updatedAt
    }
  }
`;
export const createCompaniesContactPersons = /* GraphQL */ `
  mutation CreateCompaniesContactPersons(
    $input: CreateCompaniesContactPersonsInput!
    $condition: ModelCompaniesContactPersonsConditionInput
  ) {
    createCompaniesContactPersons(input: $input, condition: $condition) {
      id
      companyID
      leadShare
      contactPersonUserId
      userID
      email
      firstName
      lastName
      mobil
      phone
      position
      countryCode
      inactive
      hubspotContactId
      leadfeederContactId
      salutation
      gender
      personalSalutation
      communicationLanguage
      hubspotRaw
      companyName
      createdAt
      updatedAt
    }
  }
`;
export const updateCompaniesContactPersons = /* GraphQL */ `
  mutation UpdateCompaniesContactPersons(
    $input: UpdateCompaniesContactPersonsInput!
    $condition: ModelCompaniesContactPersonsConditionInput
  ) {
    updateCompaniesContactPersons(input: $input, condition: $condition) {
      id
      companyID
      leadShare
      contactPersonUserId
      userID
      email
      firstName
      lastName
      mobil
      phone
      position
      countryCode
      inactive
      hubspotContactId
      leadfeederContactId
      salutation
      gender
      personalSalutation
      communicationLanguage
      hubspotRaw
      companyName
      createdAt
      updatedAt
    }
  }
`;
export const deleteCompaniesContactPersons = /* GraphQL */ `
  mutation DeleteCompaniesContactPersons(
    $input: DeleteCompaniesContactPersonsInput!
    $condition: ModelCompaniesContactPersonsConditionInput
  ) {
    deleteCompaniesContactPersons(input: $input, condition: $condition) {
      id
      companyID
      leadShare
      contactPersonUserId
      userID
      email
      firstName
      lastName
      mobil
      phone
      position
      countryCode
      inactive
      hubspotContactId
      leadfeederContactId
      salutation
      gender
      personalSalutation
      communicationLanguage
      hubspotRaw
      companyName
      createdAt
      updatedAt
    }
  }
`;
export const createCompaniesProductCategories = /* GraphQL */ `
  mutation CreateCompaniesProductCategories(
    $input: CreateCompaniesProductCategoriesInput!
    $condition: ModelCompaniesProductCategoriesConditionInput
  ) {
    createCompaniesProductCategories(input: $input, condition: $condition) {
      id
      companyId
      categoryId
      countryCode
      finalStage
      isAccepted
      createdAt
      updatedAt
    }
  }
`;
export const updateCompaniesProductCategories = /* GraphQL */ `
  mutation UpdateCompaniesProductCategories(
    $input: UpdateCompaniesProductCategoriesInput!
    $condition: ModelCompaniesProductCategoriesConditionInput
  ) {
    updateCompaniesProductCategories(input: $input, condition: $condition) {
      id
      companyId
      categoryId
      countryCode
      finalStage
      isAccepted
      createdAt
      updatedAt
    }
  }
`;
export const deleteCompaniesProductCategories = /* GraphQL */ `
  mutation DeleteCompaniesProductCategories(
    $input: DeleteCompaniesProductCategoriesInput!
    $condition: ModelCompaniesProductCategoriesConditionInput
  ) {
    deleteCompaniesProductCategories(input: $input, condition: $condition) {
      id
      companyId
      categoryId
      countryCode
      finalStage
      isAccepted
      createdAt
      updatedAt
    }
  }
`;
export const createCustoms = /* GraphQL */ `
  mutation CreateCustoms(
    $input: CreateCustomsInput!
    $condition: ModelCustomsConditionInput
  ) {
    createCustoms(input: $input, condition: $condition) {
      id
      currentCustomsStatus
      createdAt
      originCountry
      releaseDate
      positionNumber
      mrnNumber
      sentMrnNumber
      customsLocation
      baseType
      updatedAt
    }
  }
`;
export const updateCustoms = /* GraphQL */ `
  mutation UpdateCustoms(
    $input: UpdateCustomsInput!
    $condition: ModelCustomsConditionInput
  ) {
    updateCustoms(input: $input, condition: $condition) {
      id
      currentCustomsStatus
      createdAt
      originCountry
      releaseDate
      positionNumber
      mrnNumber
      sentMrnNumber
      customsLocation
      baseType
      updatedAt
    }
  }
`;
export const deleteCustoms = /* GraphQL */ `
  mutation DeleteCustoms(
    $input: DeleteCustomsInput!
    $condition: ModelCustomsConditionInput
  ) {
    deleteCustoms(input: $input, condition: $condition) {
      id
      currentCustomsStatus
      createdAt
      originCountry
      releaseDate
      positionNumber
      mrnNumber
      sentMrnNumber
      customsLocation
      baseType
      updatedAt
    }
  }
`;
export const createUsers = /* GraphQL */ `
  mutation CreateUsers(
    $input: CreateUsersInput!
    $condition: ModelUsersConditionInput
  ) {
    createUsers(input: $input, condition: $condition) {
      id
      companyId
      companyContactPersonUserId
      country
      contactPersonUserId
      email
      baseType
      imageUrl
      lastLogin
      firstName
      lastName
      language
      mobil
      phone
      position
      pushNotifications
      notifications
      forms
      productTourStatus
      roleId
      settings
      twoFactorEnabled
      createdAt
      updatedAt
      countryCode
    }
  }
`;
export const updateUsers = /* GraphQL */ `
  mutation UpdateUsers(
    $input: UpdateUsersInput!
    $condition: ModelUsersConditionInput
  ) {
    updateUsers(input: $input, condition: $condition) {
      id
      companyId
      companyContactPersonUserId
      country
      contactPersonUserId
      email
      baseType
      imageUrl
      lastLogin
      firstName
      lastName
      language
      mobil
      phone
      position
      pushNotifications
      notifications
      forms
      productTourStatus
      roleId
      settings
      twoFactorEnabled
      createdAt
      updatedAt
      countryCode
    }
  }
`;
export const createContactPersons = /* GraphQL */ `
  mutation CreateContactPersons(
    $input: CreateContactPersonsInput!
    $condition: ModelContactPersonsConditionInput
  ) {
    createContactPersons(input: $input, condition: $condition) {
      id
      email
      imageUrl
      firstName
      lastName
      mobil
      phone
      position
      funnelColor
      hubspotId
      sapEmployeeId
      countries
      type
      funnel
      defaultContactPerson
      createdAt
      updatedAt
    }
  }
`;
export const updateContactPersons = /* GraphQL */ `
  mutation UpdateContactPersons(
    $input: UpdateContactPersonsInput!
    $condition: ModelContactPersonsConditionInput
  ) {
    updateContactPersons(input: $input, condition: $condition) {
      id
      email
      imageUrl
      firstName
      lastName
      mobil
      phone
      position
      funnelColor
      hubspotId
      sapEmployeeId
      countries
      type
      funnel
      defaultContactPerson
      createdAt
      updatedAt
    }
  }
`;
export const deleteContactPersons = /* GraphQL */ `
  mutation DeleteContactPersons(
    $input: DeleteContactPersonsInput!
    $condition: ModelContactPersonsConditionInput
  ) {
    deleteContactPersons(input: $input, condition: $condition) {
      id
      email
      imageUrl
      firstName
      lastName
      mobil
      phone
      position
      funnelColor
      hubspotId
      sapEmployeeId
      countries
      type
      funnel
      defaultContactPerson
      createdAt
      updatedAt
    }
  }
`;
export const createUserRoles = /* GraphQL */ `
  mutation CreateUserRoles(
    $input: CreateUserRolesInput!
    $condition: ModelUserRolesConditionInput
  ) {
    createUserRoles(input: $input, condition: $condition) {
      id
      roleName
      type
      cognitoUserGroup
      permissions
      invitableCompanyTypes
      createdAt
      updatedAt
    }
  }
`;
export const updateUserRoles = /* GraphQL */ `
  mutation UpdateUserRoles(
    $input: UpdateUserRolesInput!
    $condition: ModelUserRolesConditionInput
  ) {
    updateUserRoles(input: $input, condition: $condition) {
      id
      roleName
      type
      cognitoUserGroup
      permissions
      invitableCompanyTypes
      createdAt
      updatedAt
    }
  }
`;
export const deleteUserRoles = /* GraphQL */ `
  mutation DeleteUserRoles(
    $input: DeleteUserRolesInput!
    $condition: ModelUserRolesConditionInput
  ) {
    deleteUserRoles(input: $input, condition: $condition) {
      id
      roleName
      type
      cognitoUserGroup
      permissions
      invitableCompanyTypes
      createdAt
      updatedAt
    }
  }
`;
export const createInvitations = /* GraphQL */ `
  mutation CreateInvitations(
    $input: CreateInvitationsInput!
    $condition: ModelInvitationsConditionInput
  ) {
    createInvitations(input: $input, condition: $condition) {
      id
      companyId
      createdAt
      email
      invitedByUserId
      invitedByUserName
      invitedByUserEmail
      language
      roleId
      countryCode
      reminderStatus
      ttl
      updatedAt
    }
  }
`;
export const updateInvitations = /* GraphQL */ `
  mutation UpdateInvitations(
    $input: UpdateInvitationsInput!
    $condition: ModelInvitationsConditionInput
  ) {
    updateInvitations(input: $input, condition: $condition) {
      id
      companyId
      createdAt
      email
      invitedByUserId
      invitedByUserName
      invitedByUserEmail
      language
      roleId
      countryCode
      reminderStatus
      ttl
      updatedAt
    }
  }
`;
export const deleteInvitations = /* GraphQL */ `
  mutation DeleteInvitations(
    $input: DeleteInvitationsInput!
    $condition: ModelInvitationsConditionInput
  ) {
    deleteInvitations(input: $input, condition: $condition) {
      id
      companyId
      createdAt
      email
      invitedByUserId
      invitedByUserName
      invitedByUserEmail
      language
      roleId
      countryCode
      reminderStatus
      ttl
      updatedAt
    }
  }
`;
export const createNotifications = /* GraphQL */ `
  mutation CreateNotifications(
    $input: CreateNotificationsInput!
    $condition: ModelNotificationsConditionInput
  ) {
    createNotifications(input: $input, condition: $condition) {
      createdAt
      updatedAt
      id
      userEmail
      title
      message
      userRead
      reference
      read
      userId
      icon
      iconBackgroundColor
      type
      emailNotification
      pushNotification
      ttl
    }
  }
`;
export const updateNotifications = /* GraphQL */ `
  mutation UpdateNotifications(
    $input: UpdateNotificationsInput!
    $condition: ModelNotificationsConditionInput
  ) {
    updateNotifications(input: $input, condition: $condition) {
      createdAt
      updatedAt
      id
      userEmail
      title
      message
      userRead
      reference
      read
      userId
      icon
      iconBackgroundColor
      type
      emailNotification
      pushNotification
      ttl
    }
  }
`;
export const deleteNotifications = /* GraphQL */ `
  mutation DeleteNotifications(
    $input: DeleteNotificationsInput!
    $condition: ModelNotificationsConditionInput
  ) {
    deleteNotifications(input: $input, condition: $condition) {
      createdAt
      updatedAt
      id
      userEmail
      title
      message
      userRead
      reference
      read
      userId
      icon
      iconBackgroundColor
      type
      emailNotification
      pushNotification
      ttl
    }
  }
`;
export const createOrders = /* GraphQL */ `
  mutation CreateOrders(
    $input: CreateOrdersInput!
    $condition: ModelOrdersConditionInput
  ) {
    createOrders(input: $input, condition: $condition) {
      id
      createdAt
      orderDate
      cancelled
      disableAutoStatusUpdates
      companyId
      contactPersonUserId
      currentOrderStatus
      customerReference
      confirmed
      openingRemark
      closingRemark
      salesOfferId
      plannedTransportationType
      paymentConditions
      orderNumber
      sapCompanyName
      sapConfirmedDeliveryDate
      predictiveDeliveryDate
      sapCustomerNumber
      createdByUserId
      purchaseOrder
      baseType
      completedAt
      updatedAt
    }
  }
`;
export const updateOrders = /* GraphQL */ `
  mutation UpdateOrders(
    $input: UpdateOrdersInput!
    $condition: ModelOrdersConditionInput
  ) {
    updateOrders(input: $input, condition: $condition) {
      id
      createdAt
      orderDate
      cancelled
      disableAutoStatusUpdates
      companyId
      contactPersonUserId
      currentOrderStatus
      customerReference
      confirmed
      openingRemark
      closingRemark
      salesOfferId
      plannedTransportationType
      paymentConditions
      orderNumber
      sapCompanyName
      sapConfirmedDeliveryDate
      predictiveDeliveryDate
      sapCustomerNumber
      createdByUserId
      purchaseOrder
      baseType
      completedAt
      updatedAt
    }
  }
`;
export const deleteOrders = /* GraphQL */ `
  mutation DeleteOrders(
    $input: DeleteOrdersInput!
    $condition: ModelOrdersConditionInput
  ) {
    deleteOrders(input: $input, condition: $condition) {
      id
      createdAt
      orderDate
      cancelled
      disableAutoStatusUpdates
      companyId
      contactPersonUserId
      currentOrderStatus
      customerReference
      confirmed
      openingRemark
      closingRemark
      salesOfferId
      plannedTransportationType
      paymentConditions
      orderNumber
      sapCompanyName
      sapConfirmedDeliveryDate
      predictiveDeliveryDate
      sapCustomerNumber
      createdByUserId
      purchaseOrder
      baseType
      completedAt
      updatedAt
    }
  }
`;
export const createOrderItems = /* GraphQL */ `
  mutation CreateOrderItems(
    $input: CreateOrderItemsInput!
    $condition: ModelOrderItemsConditionInput
  ) {
    createOrderItems(input: $input, condition: $condition) {
      id
      companyId
      itemsID
      createdAt
      deliveryDate
      orderDate
      currentOrderStatus
      customerItemNumber
      customerReference
      number
      quantity
      title
      ean
      hsCode
      sapLineNumber
      ordersID
      contactPersonUserId
      purchaseOrderItemsID
      purchaseOrderItemsManual
      baseType
      updatedAt
    }
  }
`;
export const updateOrderItems = /* GraphQL */ `
  mutation UpdateOrderItems(
    $input: UpdateOrderItemsInput!
    $condition: ModelOrderItemsConditionInput
  ) {
    updateOrderItems(input: $input, condition: $condition) {
      id
      companyId
      itemsID
      createdAt
      deliveryDate
      orderDate
      currentOrderStatus
      customerItemNumber
      customerReference
      number
      quantity
      title
      ean
      hsCode
      sapLineNumber
      ordersID
      contactPersonUserId
      purchaseOrderItemsID
      purchaseOrderItemsManual
      baseType
      updatedAt
    }
  }
`;
export const deleteOrderItems = /* GraphQL */ `
  mutation DeleteOrderItems(
    $input: DeleteOrderItemsInput!
    $condition: ModelOrderItemsConditionInput
  ) {
    deleteOrderItems(input: $input, condition: $condition) {
      id
      companyId
      itemsID
      createdAt
      deliveryDate
      orderDate
      currentOrderStatus
      customerItemNumber
      customerReference
      number
      quantity
      title
      ean
      hsCode
      sapLineNumber
      ordersID
      contactPersonUserId
      purchaseOrderItemsID
      purchaseOrderItemsManual
      baseType
      updatedAt
    }
  }
`;
export const createShipments = /* GraphQL */ `
  mutation CreateShipments(
    $input: CreateShipmentsInput!
    $condition: ModelShipmentsConditionInput
  ) {
    createShipments(input: $input, condition: $condition) {
      id
      size
      originCountry
      createdAt
      customsMrnNumber
      freeText
      manualTracking
      trackingInformation
      positionNumber
      deliveriesID
      paymentStatus
      currentShipmentStatus
      type
      companyIds
      sealNumber
      etd
      eta
      position
      googleId
      telexReleaseStatus
      customsClearanceStatus
      trackingCode
      customsID
      ownerIds
      baseType
      companyID
      demurrageTime
      detentionTime
      storageTime
      updatedAt
    }
  }
`;
export const updateShipments = /* GraphQL */ `
  mutation UpdateShipments(
    $input: UpdateShipmentsInput!
    $condition: ModelShipmentsConditionInput
  ) {
    updateShipments(input: $input, condition: $condition) {
      id
      size
      originCountry
      createdAt
      customsMrnNumber
      freeText
      manualTracking
      trackingInformation
      positionNumber
      deliveriesID
      paymentStatus
      currentShipmentStatus
      type
      companyIds
      sealNumber
      etd
      eta
      position
      googleId
      telexReleaseStatus
      customsClearanceStatus
      trackingCode
      customsID
      ownerIds
      baseType
      companyID
      demurrageTime
      detentionTime
      storageTime
      updatedAt
    }
  }
`;
export const deleteShipments = /* GraphQL */ `
  mutation DeleteShipments(
    $input: DeleteShipmentsInput!
    $condition: ModelShipmentsConditionInput
  ) {
    deleteShipments(input: $input, condition: $condition) {
      id
      size
      originCountry
      createdAt
      customsMrnNumber
      freeText
      manualTracking
      trackingInformation
      positionNumber
      deliveriesID
      paymentStatus
      currentShipmentStatus
      type
      companyIds
      sealNumber
      etd
      eta
      position
      googleId
      telexReleaseStatus
      customsClearanceStatus
      trackingCode
      customsID
      ownerIds
      baseType
      companyID
      demurrageTime
      detentionTime
      storageTime
      updatedAt
    }
  }
`;
export const createPurchaseOrders = /* GraphQL */ `
  mutation CreatePurchaseOrders(
    $input: CreatePurchaseOrdersInput!
    $condition: ModelPurchaseOrdersConditionInput
  ) {
    createPurchaseOrders(input: $input, condition: $condition) {
      id
      createdAt
      cancelled
      country
      companyID
      currentPurchaseOrderStatus
      finishedDate
      sapFinishedDate
      manufacturerContactPersonUserId
      purchaseOrderNumber
      sapReference
      sapSupplierNumber
      sapSupplierCompanyName
      confirmed
      openingRemark
      closingRemark
      plannedTransportationType
      destination
      paymentConditions
      paymentStatus
      title
      salesConfirmationNumber
      googleId
      orderIdsGoogle
      baseType
      updatedAt
    }
  }
`;
export const updatePurchaseOrders = /* GraphQL */ `
  mutation UpdatePurchaseOrders(
    $input: UpdatePurchaseOrdersInput!
    $condition: ModelPurchaseOrdersConditionInput
  ) {
    updatePurchaseOrders(input: $input, condition: $condition) {
      id
      createdAt
      cancelled
      country
      companyID
      currentPurchaseOrderStatus
      finishedDate
      sapFinishedDate
      manufacturerContactPersonUserId
      purchaseOrderNumber
      sapReference
      sapSupplierNumber
      sapSupplierCompanyName
      confirmed
      openingRemark
      closingRemark
      plannedTransportationType
      destination
      paymentConditions
      paymentStatus
      title
      salesConfirmationNumber
      googleId
      orderIdsGoogle
      baseType
      updatedAt
    }
  }
`;
export const deletePurchaseOrders = /* GraphQL */ `
  mutation DeletePurchaseOrders(
    $input: DeletePurchaseOrdersInput!
    $condition: ModelPurchaseOrdersConditionInput
  ) {
    deletePurchaseOrders(input: $input, condition: $condition) {
      id
      createdAt
      cancelled
      country
      companyID
      currentPurchaseOrderStatus
      finishedDate
      sapFinishedDate
      manufacturerContactPersonUserId
      purchaseOrderNumber
      sapReference
      sapSupplierNumber
      sapSupplierCompanyName
      confirmed
      openingRemark
      closingRemark
      plannedTransportationType
      destination
      paymentConditions
      paymentStatus
      title
      salesConfirmationNumber
      googleId
      orderIdsGoogle
      baseType
      updatedAt
    }
  }
`;
export const createPurchaseOrderItems = /* GraphQL */ `
  mutation CreatePurchaseOrderItems(
    $input: CreatePurchaseOrderItemsInput!
    $condition: ModelPurchaseOrderItemsConditionInput
  ) {
    createPurchaseOrderItems(input: $input, condition: $condition) {
      id
      purchaseOrdersID
      paymentStatus
      createdAt
      country
      companyID
      itemsID
      currentPurchaseOrderStatus
      finishedDate
      manufacturerItemNumber
      number
      quantity
      title
      ean
      hsCode
      sapLineNumber
      orderNumberReference
      sapOrderLineNumberReference
      sapFinishedDate
      updatedAt
    }
  }
`;
export const updatePurchaseOrderItems = /* GraphQL */ `
  mutation UpdatePurchaseOrderItems(
    $input: UpdatePurchaseOrderItemsInput!
    $condition: ModelPurchaseOrderItemsConditionInput
  ) {
    updatePurchaseOrderItems(input: $input, condition: $condition) {
      id
      purchaseOrdersID
      paymentStatus
      createdAt
      country
      companyID
      itemsID
      currentPurchaseOrderStatus
      finishedDate
      manufacturerItemNumber
      number
      quantity
      title
      ean
      hsCode
      sapLineNumber
      orderNumberReference
      sapOrderLineNumberReference
      sapFinishedDate
      updatedAt
    }
  }
`;
export const deletePurchaseOrderItems = /* GraphQL */ `
  mutation DeletePurchaseOrderItems(
    $input: DeletePurchaseOrderItemsInput!
    $condition: ModelPurchaseOrderItemsConditionInput
  ) {
    deletePurchaseOrderItems(input: $input, condition: $condition) {
      id
      purchaseOrdersID
      paymentStatus
      createdAt
      country
      companyID
      itemsID
      currentPurchaseOrderStatus
      finishedDate
      manufacturerItemNumber
      number
      quantity
      title
      ean
      hsCode
      sapLineNumber
      orderNumberReference
      sapOrderLineNumberReference
      sapFinishedDate
      updatedAt
    }
  }
`;
export const createSupplierPurchaseOrders = /* GraphQL */ `
  mutation CreateSupplierPurchaseOrders(
    $input: CreateSupplierPurchaseOrdersInput!
    $condition: ModelSupplierPurchaseOrdersConditionInput
  ) {
    createSupplierPurchaseOrders(input: $input, condition: $condition) {
      id
      createdAt
      cancelled
      country
      companyID
      currentPurchaseOrderStatus
      finishedDate
      sapFinishedDate
      manufacturerContactPersonUserId
      purchaseOrderNumber
      purchaseOrdersID
      salesConfirmationNumber
      baseType
      updatedAt
    }
  }
`;
export const updateSupplierPurchaseOrders = /* GraphQL */ `
  mutation UpdateSupplierPurchaseOrders(
    $input: UpdateSupplierPurchaseOrdersInput!
    $condition: ModelSupplierPurchaseOrdersConditionInput
  ) {
    updateSupplierPurchaseOrders(input: $input, condition: $condition) {
      id
      createdAt
      cancelled
      country
      companyID
      currentPurchaseOrderStatus
      finishedDate
      sapFinishedDate
      manufacturerContactPersonUserId
      purchaseOrderNumber
      purchaseOrdersID
      salesConfirmationNumber
      baseType
      updatedAt
    }
  }
`;
export const deleteSupplierPurchaseOrders = /* GraphQL */ `
  mutation DeleteSupplierPurchaseOrders(
    $input: DeleteSupplierPurchaseOrdersInput!
    $condition: ModelSupplierPurchaseOrdersConditionInput
  ) {
    deleteSupplierPurchaseOrders(input: $input, condition: $condition) {
      id
      createdAt
      cancelled
      country
      companyID
      currentPurchaseOrderStatus
      finishedDate
      sapFinishedDate
      manufacturerContactPersonUserId
      purchaseOrderNumber
      purchaseOrdersID
      salesConfirmationNumber
      baseType
      updatedAt
    }
  }
`;
export const createSupplierPurchaseOrderItems = /* GraphQL */ `
  mutation CreateSupplierPurchaseOrderItems(
    $input: CreateSupplierPurchaseOrderItemsInput!
    $condition: ModelSupplierPurchaseOrderItemsConditionInput
  ) {
    createSupplierPurchaseOrderItems(input: $input, condition: $condition) {
      id
      purchaseOrderItemsID
      supplierPurchaseOrdersID
      createdAt
      country
      companyID
      currentPurchaseOrderStatus
      finishedDate
      manufacturerItemNumber
      number
      quantity
      title
      sapFinishedDate
      updatedAt
    }
  }
`;
export const updateSupplierPurchaseOrderItems = /* GraphQL */ `
  mutation UpdateSupplierPurchaseOrderItems(
    $input: UpdateSupplierPurchaseOrderItemsInput!
    $condition: ModelSupplierPurchaseOrderItemsConditionInput
  ) {
    updateSupplierPurchaseOrderItems(input: $input, condition: $condition) {
      id
      purchaseOrderItemsID
      supplierPurchaseOrdersID
      createdAt
      country
      companyID
      currentPurchaseOrderStatus
      finishedDate
      manufacturerItemNumber
      number
      quantity
      title
      sapFinishedDate
      updatedAt
    }
  }
`;
export const deleteSupplierPurchaseOrderItems = /* GraphQL */ `
  mutation DeleteSupplierPurchaseOrderItems(
    $input: DeleteSupplierPurchaseOrderItemsInput!
    $condition: ModelSupplierPurchaseOrderItemsConditionInput
  ) {
    deleteSupplierPurchaseOrderItems(input: $input, condition: $condition) {
      id
      purchaseOrderItemsID
      supplierPurchaseOrdersID
      createdAt
      country
      companyID
      currentPurchaseOrderStatus
      finishedDate
      manufacturerItemNumber
      number
      quantity
      title
      sapFinishedDate
      updatedAt
    }
  }
`;
export const createDeliveriesOrderItems = /* GraphQL */ `
  mutation CreateDeliveriesOrderItems(
    $input: CreateDeliveriesOrderItemsInput!
    $condition: ModelDeliveriesOrderItemsConditionInput
  ) {
    createDeliveriesOrderItems(input: $input, condition: $condition) {
      id
      companyId
      deliveriesID
      orderItemsID
      quantity
      comment
      createdAt
      updatedAt
      ownerIds
    }
  }
`;
export const updateDeliveriesOrderItems = /* GraphQL */ `
  mutation UpdateDeliveriesOrderItems(
    $input: UpdateDeliveriesOrderItemsInput!
    $condition: ModelDeliveriesOrderItemsConditionInput
  ) {
    updateDeliveriesOrderItems(input: $input, condition: $condition) {
      id
      companyId
      deliveriesID
      orderItemsID
      quantity
      comment
      createdAt
      updatedAt
      ownerIds
    }
  }
`;
export const deleteDeliveriesOrderItems = /* GraphQL */ `
  mutation DeleteDeliveriesOrderItems(
    $input: DeleteDeliveriesOrderItemsInput!
    $condition: ModelDeliveriesOrderItemsConditionInput
  ) {
    deleteDeliveriesOrderItems(input: $input, condition: $condition) {
      id
      companyId
      deliveriesID
      orderItemsID
      quantity
      comment
      createdAt
      updatedAt
      ownerIds
    }
  }
`;
export const createShipmentsOrderItems = /* GraphQL */ `
  mutation CreateShipmentsOrderItems(
    $input: CreateShipmentsOrderItemsInput!
    $condition: ModelShipmentsOrderItemsConditionInput
  ) {
    createShipmentsOrderItems(input: $input, condition: $condition) {
      id
      companyId
      shipmentsID
      orderItemsID
      quantity
      createdAt
      updatedAt
    }
  }
`;
export const updateShipmentsOrderItems = /* GraphQL */ `
  mutation UpdateShipmentsOrderItems(
    $input: UpdateShipmentsOrderItemsInput!
    $condition: ModelShipmentsOrderItemsConditionInput
  ) {
    updateShipmentsOrderItems(input: $input, condition: $condition) {
      id
      companyId
      shipmentsID
      orderItemsID
      quantity
      createdAt
      updatedAt
    }
  }
`;
export const deleteShipmentsOrderItems = /* GraphQL */ `
  mutation DeleteShipmentsOrderItems(
    $input: DeleteShipmentsOrderItemsInput!
    $condition: ModelShipmentsOrderItemsConditionInput
  ) {
    deleteShipmentsOrderItems(input: $input, condition: $condition) {
      id
      companyId
      shipmentsID
      orderItemsID
      quantity
      createdAt
      updatedAt
    }
  }
`;
export const createShipmentsPurchaseOrderItems = /* GraphQL */ `
  mutation CreateShipmentsPurchaseOrderItems(
    $input: CreateShipmentsPurchaseOrderItemsInput!
    $condition: ModelShipmentsPurchaseOrderItemsConditionInput
  ) {
    createShipmentsPurchaseOrderItems(input: $input, condition: $condition) {
      id
      shipmentsID
      purchaseOrderItemsID
      quantity
      comment
      createdAt
      updatedAt
    }
  }
`;
export const updateShipmentsPurchaseOrderItems = /* GraphQL */ `
  mutation UpdateShipmentsPurchaseOrderItems(
    $input: UpdateShipmentsPurchaseOrderItemsInput!
    $condition: ModelShipmentsPurchaseOrderItemsConditionInput
  ) {
    updateShipmentsPurchaseOrderItems(input: $input, condition: $condition) {
      id
      shipmentsID
      purchaseOrderItemsID
      quantity
      comment
      createdAt
      updatedAt
    }
  }
`;
export const deleteShipmentsPurchaseOrderItems = /* GraphQL */ `
  mutation DeleteShipmentsPurchaseOrderItems(
    $input: DeleteShipmentsPurchaseOrderItemsInput!
    $condition: ModelShipmentsPurchaseOrderItemsConditionInput
  ) {
    deleteShipmentsPurchaseOrderItems(input: $input, condition: $condition) {
      id
      shipmentsID
      purchaseOrderItemsID
      quantity
      comment
      createdAt
      updatedAt
    }
  }
`;
export const createAnalytics = /* GraphQL */ `
  mutation CreateAnalytics(
    $input: CreateAnalyticsInput!
    $condition: ModelAnalyticsConditionInput
  ) {
    createAnalytics(input: $input, condition: $condition) {
      id
      month
      year
      exchangeRates
      commodities
      createdAt
      updatedAt
    }
  }
`;
export const updateAnalytics = /* GraphQL */ `
  mutation UpdateAnalytics(
    $input: UpdateAnalyticsInput!
    $condition: ModelAnalyticsConditionInput
  ) {
    updateAnalytics(input: $input, condition: $condition) {
      id
      month
      year
      exchangeRates
      commodities
      createdAt
      updatedAt
    }
  }
`;
export const deleteAnalytics = /* GraphQL */ `
  mutation DeleteAnalytics(
    $input: DeleteAnalyticsInput!
    $condition: ModelAnalyticsConditionInput
  ) {
    deleteAnalytics(input: $input, condition: $condition) {
      id
      month
      year
      exchangeRates
      commodities
      createdAt
      updatedAt
    }
  }
`;
export const createDeliveries = /* GraphQL */ `
  mutation CreateDeliveries(
    $input: CreateDeliveriesInput!
    $condition: ModelDeliveriesConditionInput
  ) {
    createDeliveries(input: $input, condition: $condition) {
      id
      createdAt
      size
      trackingInformation
      positionNumber
      shipmentsID
      currentDeliveryStatus
      sealNumber
      type
      transportationType
      companyIds
      companyID
      etd
      eta
      distance
      position
      trackingCode
      googleId
      ownerIds
      baseType
      updatedAt
    }
  }
`;
export const updateDeliveries = /* GraphQL */ `
  mutation UpdateDeliveries(
    $input: UpdateDeliveriesInput!
    $condition: ModelDeliveriesConditionInput
  ) {
    updateDeliveries(input: $input, condition: $condition) {
      id
      createdAt
      size
      trackingInformation
      positionNumber
      shipmentsID
      currentDeliveryStatus
      sealNumber
      type
      transportationType
      companyIds
      companyID
      etd
      eta
      distance
      position
      trackingCode
      googleId
      ownerIds
      baseType
      updatedAt
    }
  }
`;
export const deleteDeliveries = /* GraphQL */ `
  mutation DeleteDeliveries(
    $input: DeleteDeliveriesInput!
    $condition: ModelDeliveriesConditionInput
  ) {
    deleteDeliveries(input: $input, condition: $condition) {
      id
      createdAt
      size
      trackingInformation
      positionNumber
      shipmentsID
      currentDeliveryStatus
      sealNumber
      type
      transportationType
      companyIds
      companyID
      etd
      eta
      distance
      position
      trackingCode
      googleId
      ownerIds
      baseType
      updatedAt
    }
  }
`;
export const createDocuments = /* GraphQL */ `
  mutation CreateDocuments(
    $input: CreateDocumentsInput!
    $condition: ModelDocumentsConditionInput
  ) {
    createDocuments(input: $input, condition: $condition) {
      id
      createdAt
      companyId
      companiesIDs
      collectionName
      storageKey
      type
      name
      fileType
      storageUrl
      countries
      country
      objectID
      languageCode
      documentGroup
      documentUser
      relatedCompanyId
      updatedAt
    }
  }
`;
export const updateDocuments = /* GraphQL */ `
  mutation UpdateDocuments(
    $input: UpdateDocumentsInput!
    $condition: ModelDocumentsConditionInput
  ) {
    updateDocuments(input: $input, condition: $condition) {
      id
      createdAt
      companyId
      companiesIDs
      collectionName
      storageKey
      type
      name
      fileType
      storageUrl
      countries
      country
      objectID
      languageCode
      documentGroup
      documentUser
      relatedCompanyId
      updatedAt
    }
  }
`;
export const deleteDocuments = /* GraphQL */ `
  mutation DeleteDocuments(
    $input: DeleteDocumentsInput!
    $condition: ModelDocumentsConditionInput
  ) {
    deleteDocuments(input: $input, condition: $condition) {
      id
      createdAt
      companyId
      companiesIDs
      collectionName
      storageKey
      type
      name
      fileType
      storageUrl
      countries
      country
      objectID
      languageCode
      documentGroup
      documentUser
      relatedCompanyId
      updatedAt
    }
  }
`;
export const createCertificates = /* GraphQL */ `
  mutation CreateCertificates(
    $input: CreateCertificatesInput!
    $condition: ModelCertificatesConditionInput
  ) {
    createCertificates(input: $input, condition: $condition) {
      id
      createdAt
      companyId
      storageKey
      type
      name
      fileType
      storageUrl
      country
      objectID
      collectionName
      validUntil
      status
      updatedAt
    }
  }
`;
export const updateCertificates = /* GraphQL */ `
  mutation UpdateCertificates(
    $input: UpdateCertificatesInput!
    $condition: ModelCertificatesConditionInput
  ) {
    updateCertificates(input: $input, condition: $condition) {
      id
      createdAt
      companyId
      storageKey
      type
      name
      fileType
      storageUrl
      country
      objectID
      collectionName
      validUntil
      status
      updatedAt
    }
  }
`;
export const deleteCertificates = /* GraphQL */ `
  mutation DeleteCertificates(
    $input: DeleteCertificatesInput!
    $condition: ModelCertificatesConditionInput
  ) {
    deleteCertificates(input: $input, condition: $condition) {
      id
      createdAt
      companyId
      storageKey
      type
      name
      fileType
      storageUrl
      country
      objectID
      collectionName
      validUntil
      status
      updatedAt
    }
  }
`;
export const createCompaniesAnalytics = /* GraphQL */ `
  mutation CreateCompaniesAnalytics(
    $input: CreateCompaniesAnalyticsInput!
    $condition: ModelCompaniesAnalyticsConditionInput
  ) {
    createCompaniesAnalytics(input: $input, condition: $condition) {
      id
      year
      month
      createdAt
      quantityInvoices
      quantityOrders
      turnoverInvoices
      turnoverOrders
      productRequests
      customerRequests
      cbam
      topCategories
      qrPassed
      qrTotal
      otdOnTime
      otdTotal
      otdDelayDays
      crConfirmed
      crTotal
      canCancelled
      canTotal
      convConverted
      convTotal
      dirty
      companyID
      updatedAt
    }
  }
`;
export const updateCompaniesAnalytics = /* GraphQL */ `
  mutation UpdateCompaniesAnalytics(
    $input: UpdateCompaniesAnalyticsInput!
    $condition: ModelCompaniesAnalyticsConditionInput
  ) {
    updateCompaniesAnalytics(input: $input, condition: $condition) {
      id
      year
      month
      createdAt
      quantityInvoices
      quantityOrders
      turnoverInvoices
      turnoverOrders
      productRequests
      customerRequests
      cbam
      topCategories
      qrPassed
      qrTotal
      otdOnTime
      otdTotal
      otdDelayDays
      crConfirmed
      crTotal
      canCancelled
      canTotal
      convConverted
      convTotal
      dirty
      companyID
      updatedAt
    }
  }
`;
export const deleteCompaniesAnalytics = /* GraphQL */ `
  mutation DeleteCompaniesAnalytics(
    $input: DeleteCompaniesAnalyticsInput!
    $condition: ModelCompaniesAnalyticsConditionInput
  ) {
    deleteCompaniesAnalytics(input: $input, condition: $condition) {
      id
      year
      month
      createdAt
      quantityInvoices
      quantityOrders
      turnoverInvoices
      turnoverOrders
      productRequests
      customerRequests
      cbam
      topCategories
      qrPassed
      qrTotal
      otdOnTime
      otdTotal
      otdDelayDays
      crConfirmed
      crTotal
      canCancelled
      canTotal
      convConverted
      convTotal
      dirty
      companyID
      updatedAt
    }
  }
`;
export const createProductRequests = /* GraphQL */ `
  mutation CreateProductRequests(
    $input: CreateProductRequestsInput!
    $condition: ModelProductRequestsConditionInput
  ) {
    createProductRequests(input: $input, condition: $condition) {
      id
      createdAt
      channel
      customerRequestsID
      priority
      involvedUsersIds
      countries
      dueDate
      currentProductRequestStatus
      positionNumber
      sentOverdueReminder
      title
      freeText
      customerCompanyID
      baseType
      updatedAt
    }
  }
`;
export const updateProductRequests = /* GraphQL */ `
  mutation UpdateProductRequests(
    $input: UpdateProductRequestsInput!
    $condition: ModelProductRequestsConditionInput
  ) {
    updateProductRequests(input: $input, condition: $condition) {
      id
      createdAt
      channel
      customerRequestsID
      priority
      involvedUsersIds
      countries
      dueDate
      currentProductRequestStatus
      positionNumber
      sentOverdueReminder
      title
      freeText
      customerCompanyID
      baseType
      updatedAt
    }
  }
`;
export const deleteProductRequests = /* GraphQL */ `
  mutation DeleteProductRequests(
    $input: DeleteProductRequestsInput!
    $condition: ModelProductRequestsConditionInput
  ) {
    deleteProductRequests(input: $input, condition: $condition) {
      id
      createdAt
      channel
      customerRequestsID
      priority
      involvedUsersIds
      countries
      dueDate
      currentProductRequestStatus
      positionNumber
      sentOverdueReminder
      title
      freeText
      customerCompanyID
      baseType
      updatedAt
    }
  }
`;
export const createItems = /* GraphQL */ `
  mutation CreateItems(
    $input: CreateItemsInput!
    $condition: ModelItemsConditionInput
  ) {
    createItems(input: $input, condition: $condition) {
      id
      companyIDs
      companyID
      createdAt
      customerArticleNumber
      customerRevisionStatus
      title
      description
      number
      ean
      active
      itemsHeadID
      customsRate
      hsCode
      tariffCode
      material
      coverImageId
      countries
      baseType
      categoryId
      updatedAt
    }
  }
`;
export const updateItems = /* GraphQL */ `
  mutation UpdateItems(
    $input: UpdateItemsInput!
    $condition: ModelItemsConditionInput
  ) {
    updateItems(input: $input, condition: $condition) {
      id
      companyIDs
      companyID
      createdAt
      customerArticleNumber
      customerRevisionStatus
      title
      description
      number
      ean
      active
      itemsHeadID
      customsRate
      hsCode
      tariffCode
      material
      coverImageId
      countries
      baseType
      categoryId
      updatedAt
    }
  }
`;
export const deleteItems = /* GraphQL */ `
  mutation DeleteItems(
    $input: DeleteItemsInput!
    $condition: ModelItemsConditionInput
  ) {
    deleteItems(input: $input, condition: $condition) {
      id
      companyIDs
      companyID
      createdAt
      customerArticleNumber
      customerRevisionStatus
      title
      description
      number
      ean
      active
      itemsHeadID
      customsRate
      hsCode
      tariffCode
      material
      coverImageId
      countries
      baseType
      categoryId
      updatedAt
    }
  }
`;
export const createItemsHead = /* GraphQL */ `
  mutation CreateItemsHead(
    $input: CreateItemsHeadInput!
    $condition: ModelItemsHeadConditionInput
  ) {
    createItemsHead(input: $input, condition: $condition) {
      id
      companyIDs
      companyID
      createdAt
      hsCode
      tariffCode
      material
      customsRate
      coverImageId
      countries
      baseType
      updatedAt
    }
  }
`;
export const updateItemsHead = /* GraphQL */ `
  mutation UpdateItemsHead(
    $input: UpdateItemsHeadInput!
    $condition: ModelItemsHeadConditionInput
  ) {
    updateItemsHead(input: $input, condition: $condition) {
      id
      companyIDs
      companyID
      createdAt
      hsCode
      tariffCode
      material
      customsRate
      coverImageId
      countries
      baseType
      updatedAt
    }
  }
`;
export const deleteItemsHead = /* GraphQL */ `
  mutation DeleteItemsHead(
    $input: DeleteItemsHeadInput!
    $condition: ModelItemsHeadConditionInput
  ) {
    deleteItemsHead(input: $input, condition: $condition) {
      id
      companyIDs
      companyID
      createdAt
      hsCode
      tariffCode
      material
      customsRate
      coverImageId
      countries
      baseType
      updatedAt
    }
  }
`;
export const createItemProperties = /* GraphQL */ `
  mutation CreateItemProperties(
    $input: CreateItemPropertiesInput!
    $condition: ModelItemPropertiesConditionInput
  ) {
    createItemProperties(input: $input, condition: $condition) {
      id
      createdAt
      property
      values
      updatedAt
    }
  }
`;
export const updateItemProperties = /* GraphQL */ `
  mutation UpdateItemProperties(
    $input: UpdateItemPropertiesInput!
    $condition: ModelItemPropertiesConditionInput
  ) {
    updateItemProperties(input: $input, condition: $condition) {
      id
      createdAt
      property
      values
      updatedAt
    }
  }
`;
export const deleteItemProperties = /* GraphQL */ `
  mutation DeleteItemProperties(
    $input: DeleteItemPropertiesInput!
    $condition: ModelItemPropertiesConditionInput
  ) {
    deleteItemProperties(input: $input, condition: $condition) {
      id
      createdAt
      property
      values
      updatedAt
    }
  }
`;
export const createProductRequestsItems = /* GraphQL */ `
  mutation CreateProductRequestsItems(
    $input: CreateProductRequestsItemsInput!
    $condition: ModelProductRequestsItemsConditionInput
  ) {
    createProductRequestsItems(input: $input, condition: $condition) {
      id
      createdAt
      productRequestsID
      itemsID
      selectedPriceOffersId
      priceOffer
      selectedPriceOfferCalculation
      productionTime
      deliveryType
      quantity
      calculationTargetPrice
      targetPrice
      cbam
      margin
      excludeAdditionalCosts
      additionalCosts
      containerSize
      transportationType
      airFreightCostsPerKilo
      transportCostWarehouseToCustomer
      workingCosts
      tiersId
      updatedAt
    }
  }
`;
export const updateProductRequestsItems = /* GraphQL */ `
  mutation UpdateProductRequestsItems(
    $input: UpdateProductRequestsItemsInput!
    $condition: ModelProductRequestsItemsConditionInput
  ) {
    updateProductRequestsItems(input: $input, condition: $condition) {
      id
      createdAt
      productRequestsID
      itemsID
      selectedPriceOffersId
      priceOffer
      selectedPriceOfferCalculation
      productionTime
      deliveryType
      quantity
      calculationTargetPrice
      targetPrice
      cbam
      margin
      excludeAdditionalCosts
      additionalCosts
      containerSize
      transportationType
      airFreightCostsPerKilo
      transportCostWarehouseToCustomer
      workingCosts
      tiersId
      updatedAt
    }
  }
`;
export const createProductRequestItemPriceCalculations = /* GraphQL */ `
  mutation CreateProductRequestItemPriceCalculations(
    $input: CreateProductRequestItemPriceCalculationsInput!
    $condition: ModelProductRequestItemPriceCalculationsConditionInput
  ) {
    createProductRequestItemPriceCalculations(
      input: $input
      condition: $condition
    ) {
      id
      productRequestsItemsID
      priceOffersID
      calendarWeek
      quantity
      additionalCostsPerPieceEUR
      additionalCosts
      transportationType
      tiers
      tiersId
      salesPrice
      separatedAdditionalCosts
      pricePerPieceInEUR
      priceOfferPrice
      totalWeight
      totalVolume
      inputCbam
      inputAdditionalCostsMode
      inputAirFreightCostsPerKilo
      inputQuantity
      inputCompaniesID
      inputProductionTime
      warehouseMG
      margin
      maxMargin
      selfCosts
      targetPrice
      transportationCosts
      containerVolumeShare
      containerWeightShare
      cbamCostPerPiece
      cbamCoPerTon
      cbamPricePerTon
      workingCostPerPiece
      totalWorkingCosts
      laborRate
      maxBuyingPrice
      maxBuyingPriceCurrency
      newBuyingPriceSuggestion
      buyingPriceDifference
      customsRate
      item
      currentExchangeRates
      createdAt
      updatedAt
    }
  }
`;
export const updateProductRequestItemPriceCalculations = /* GraphQL */ `
  mutation UpdateProductRequestItemPriceCalculations(
    $input: UpdateProductRequestItemPriceCalculationsInput!
    $condition: ModelProductRequestItemPriceCalculationsConditionInput
  ) {
    updateProductRequestItemPriceCalculations(
      input: $input
      condition: $condition
    ) {
      id
      productRequestsItemsID
      priceOffersID
      calendarWeek
      quantity
      additionalCostsPerPieceEUR
      additionalCosts
      transportationType
      tiers
      tiersId
      salesPrice
      separatedAdditionalCosts
      pricePerPieceInEUR
      priceOfferPrice
      totalWeight
      totalVolume
      inputCbam
      inputAdditionalCostsMode
      inputAirFreightCostsPerKilo
      inputQuantity
      inputCompaniesID
      inputProductionTime
      warehouseMG
      margin
      maxMargin
      selfCosts
      targetPrice
      transportationCosts
      containerVolumeShare
      containerWeightShare
      cbamCostPerPiece
      cbamCoPerTon
      cbamPricePerTon
      workingCostPerPiece
      totalWorkingCosts
      laborRate
      maxBuyingPrice
      maxBuyingPriceCurrency
      newBuyingPriceSuggestion
      buyingPriceDifference
      customsRate
      item
      currentExchangeRates
      createdAt
      updatedAt
    }
  }
`;
export const deleteProductRequestItemPriceCalculations = /* GraphQL */ `
  mutation DeleteProductRequestItemPriceCalculations(
    $input: DeleteProductRequestItemPriceCalculationsInput!
    $condition: ModelProductRequestItemPriceCalculationsConditionInput
  ) {
    deleteProductRequestItemPriceCalculations(
      input: $input
      condition: $condition
    ) {
      id
      productRequestsItemsID
      priceOffersID
      calendarWeek
      quantity
      additionalCostsPerPieceEUR
      additionalCosts
      transportationType
      tiers
      tiersId
      salesPrice
      separatedAdditionalCosts
      pricePerPieceInEUR
      priceOfferPrice
      totalWeight
      totalVolume
      inputCbam
      inputAdditionalCostsMode
      inputAirFreightCostsPerKilo
      inputQuantity
      inputCompaniesID
      inputProductionTime
      warehouseMG
      margin
      maxMargin
      selfCosts
      targetPrice
      transportationCosts
      containerVolumeShare
      containerWeightShare
      cbamCostPerPiece
      cbamCoPerTon
      cbamPricePerTon
      workingCostPerPiece
      totalWorkingCosts
      laborRate
      maxBuyingPrice
      maxBuyingPriceCurrency
      newBuyingPriceSuggestion
      buyingPriceDifference
      customsRate
      item
      currentExchangeRates
      createdAt
      updatedAt
    }
  }
`;
export const createPriceOffers = /* GraphQL */ `
  mutation CreatePriceOffers(
    $input: CreatePriceOffersInput!
    $condition: ModelPriceOffersConditionInput
  ) {
    createPriceOffers(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      country
      currency
      productionTime
      currentPriceOffer
      quantity
      companiesID
      itemsID
      supplierRequestItemsID
      userID
      negotiationThreadID
      negotiationStatus
    }
  }
`;
export const updatePriceOffers = /* GraphQL */ `
  mutation UpdatePriceOffers(
    $input: UpdatePriceOffersInput!
    $condition: ModelPriceOffersConditionInput
  ) {
    updatePriceOffers(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      country
      currency
      productionTime
      currentPriceOffer
      quantity
      companiesID
      itemsID
      supplierRequestItemsID
      userID
      negotiationThreadID
      negotiationStatus
    }
  }
`;
export const deletePriceOffers = /* GraphQL */ `
  mutation DeletePriceOffers(
    $input: DeletePriceOffersInput!
    $condition: ModelPriceOffersConditionInput
  ) {
    deletePriceOffers(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      country
      currency
      productionTime
      currentPriceOffer
      quantity
      companiesID
      itemsID
      supplierRequestItemsID
      userID
      negotiationThreadID
      negotiationStatus
    }
  }
`;
export const createNegotiationThread = /* GraphQL */ `
  mutation CreateNegotiationThread(
    $input: CreateNegotiationThreadInput!
    $condition: ModelNegotiationThreadConditionInput
  ) {
    createNegotiationThread(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      country
      supplierRequestItemsID
      itemsID
      companiesID
      status
      priceOffersID
    }
  }
`;
export const updateNegotiationThread = /* GraphQL */ `
  mutation UpdateNegotiationThread(
    $input: UpdateNegotiationThreadInput!
    $condition: ModelNegotiationThreadConditionInput
  ) {
    updateNegotiationThread(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      country
      supplierRequestItemsID
      itemsID
      companiesID
      status
      priceOffersID
    }
  }
`;
export const deleteNegotiationThread = /* GraphQL */ `
  mutation DeleteNegotiationThread(
    $input: DeleteNegotiationThreadInput!
    $condition: ModelNegotiationThreadConditionInput
  ) {
    deleteNegotiationThread(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      country
      supplierRequestItemsID
      itemsID
      companiesID
      status
      priceOffersID
    }
  }
`;
export const createNegotiationOffer = /* GraphQL */ `
  mutation CreateNegotiationOffer(
    $input: CreateNegotiationOfferInput!
    $condition: ModelNegotiationOfferConditionInput
  ) {
    createNegotiationOffer(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      country
      companiesID
      negotiationThreadID
      note
      userID
      isActive
      status
    }
  }
`;
export const updateNegotiationOffer = /* GraphQL */ `
  mutation UpdateNegotiationOffer(
    $input: UpdateNegotiationOfferInput!
    $condition: ModelNegotiationOfferConditionInput
  ) {
    updateNegotiationOffer(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      country
      companiesID
      negotiationThreadID
      note
      userID
      isActive
      status
    }
  }
`;
export const deleteNegotiationOffer = /* GraphQL */ `
  mutation DeleteNegotiationOffer(
    $input: DeleteNegotiationOfferInput!
    $condition: ModelNegotiationOfferConditionInput
  ) {
    deleteNegotiationOffer(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      country
      companiesID
      negotiationThreadID
      note
      userID
      isActive
      status
    }
  }
`;
export const createFreightRates = /* GraphQL */ `
  mutation CreateFreightRates(
    $input: CreateFreightRatesInput!
    $condition: ModelFreightRatesConditionInput
  ) {
    createFreightRates(input: $input, condition: $condition) {
      id
      createdAt
      containerSize
      from
      to
      isoWeek
      baseType
      updatedAt
    }
  }
`;
export const updateFreightRates = /* GraphQL */ `
  mutation UpdateFreightRates(
    $input: UpdateFreightRatesInput!
    $condition: ModelFreightRatesConditionInput
  ) {
    updateFreightRates(input: $input, condition: $condition) {
      id
      createdAt
      containerSize
      from
      to
      isoWeek
      baseType
      updatedAt
    }
  }
`;
export const deleteFreightRates = /* GraphQL */ `
  mutation DeleteFreightRates(
    $input: DeleteFreightRatesInput!
    $condition: ModelFreightRatesConditionInput
  ) {
    deleteFreightRates(input: $input, condition: $condition) {
      id
      createdAt
      containerSize
      from
      to
      isoWeek
      baseType
      updatedAt
    }
  }
`;
export const createTranslations = /* GraphQL */ `
  mutation CreateTranslations(
    $input: CreateTranslationsInput!
    $condition: ModelTranslationsConditionInput
  ) {
    createTranslations(input: $input, condition: $condition) {
      id
      createdAt
      languageCode
      companyIDs
      field
      translation
      translationSearch
      collectionName
      objectID
      updatedAt
    }
  }
`;
export const updateTranslations = /* GraphQL */ `
  mutation UpdateTranslations(
    $input: UpdateTranslationsInput!
    $condition: ModelTranslationsConditionInput
  ) {
    updateTranslations(input: $input, condition: $condition) {
      id
      createdAt
      languageCode
      companyIDs
      field
      translation
      translationSearch
      collectionName
      objectID
      updatedAt
    }
  }
`;
export const deleteTranslations = /* GraphQL */ `
  mutation DeleteTranslations(
    $input: DeleteTranslationsInput!
    $condition: ModelTranslationsConditionInput
  ) {
    deleteTranslations(input: $input, condition: $condition) {
      id
      createdAt
      languageCode
      companyIDs
      field
      translation
      translationSearch
      collectionName
      objectID
      updatedAt
    }
  }
`;
export const createPriceScreenings = /* GraphQL */ `
  mutation CreatePriceScreenings(
    $input: CreatePriceScreeningsInput!
    $condition: ModelPriceScreeningsConditionInput
  ) {
    createPriceScreenings(input: $input, condition: $condition) {
      id
      createdAt
      ipAddress
      device
      browser
      searchTerm
      priceCalculationMin
      priceCalculationMax
      itemsID
      updatedAt
    }
  }
`;
export const updatePriceScreenings = /* GraphQL */ `
  mutation UpdatePriceScreenings(
    $input: UpdatePriceScreeningsInput!
    $condition: ModelPriceScreeningsConditionInput
  ) {
    updatePriceScreenings(input: $input, condition: $condition) {
      id
      createdAt
      ipAddress
      device
      browser
      searchTerm
      priceCalculationMin
      priceCalculationMax
      itemsID
      updatedAt
    }
  }
`;
export const deletePriceScreenings = /* GraphQL */ `
  mutation DeletePriceScreenings(
    $input: DeletePriceScreeningsInput!
    $condition: ModelPriceScreeningsConditionInput
  ) {
    deletePriceScreenings(input: $input, condition: $condition) {
      id
      createdAt
      ipAddress
      device
      browser
      searchTerm
      priceCalculationMin
      priceCalculationMax
      itemsID
      updatedAt
    }
  }
`;
export const createCustomerRequests = /* GraphQL */ `
  mutation CreateCustomerRequests(
    $input: CreateCustomerRequestsInput!
    $condition: ModelCustomerRequestsConditionInput
  ) {
    createCustomerRequests(input: $input, condition: $condition) {
      id
      createdAt
      currentStatus
      deliveryDate
      deliveryConditions
      number
      contactPersonID
      customerContactPersonID
      notes
      companyID
      reference
      successfull
      hubspotDealId
      productRequestsID
      baseType
      updatedAt
    }
  }
`;
export const updateCustomerRequests = /* GraphQL */ `
  mutation UpdateCustomerRequests(
    $input: UpdateCustomerRequestsInput!
    $condition: ModelCustomerRequestsConditionInput
  ) {
    updateCustomerRequests(input: $input, condition: $condition) {
      id
      createdAt
      currentStatus
      deliveryDate
      deliveryConditions
      number
      contactPersonID
      customerContactPersonID
      notes
      companyID
      reference
      successfull
      hubspotDealId
      productRequestsID
      baseType
      updatedAt
    }
  }
`;
export const deleteCustomerRequests = /* GraphQL */ `
  mutation DeleteCustomerRequests(
    $input: DeleteCustomerRequestsInput!
    $condition: ModelCustomerRequestsConditionInput
  ) {
    deleteCustomerRequests(input: $input, condition: $condition) {
      id
      createdAt
      currentStatus
      deliveryDate
      deliveryConditions
      number
      contactPersonID
      customerContactPersonID
      notes
      companyID
      reference
      successfull
      hubspotDealId
      productRequestsID
      baseType
      updatedAt
    }
  }
`;
export const createCustomerRequestItems = /* GraphQL */ `
  mutation CreateCustomerRequestItems(
    $input: CreateCustomerRequestItemsInput!
    $condition: ModelCustomerRequestItemsConditionInput
  ) {
    createCustomerRequestItems(input: $input, condition: $condition) {
      id
      createdAt
      companyID
      contactPersonID
      title
      description
      customerArticleNumber
      material
      itemsID
      notes
      customerRequestsID
      baseType
      updatedAt
    }
  }
`;
export const updateCustomerRequestItems = /* GraphQL */ `
  mutation UpdateCustomerRequestItems(
    $input: UpdateCustomerRequestItemsInput!
    $condition: ModelCustomerRequestItemsConditionInput
  ) {
    updateCustomerRequestItems(input: $input, condition: $condition) {
      id
      createdAt
      companyID
      contactPersonID
      title
      description
      customerArticleNumber
      material
      itemsID
      notes
      customerRequestsID
      baseType
      updatedAt
    }
  }
`;
export const deleteCustomerRequestItems = /* GraphQL */ `
  mutation DeleteCustomerRequestItems(
    $input: DeleteCustomerRequestItemsInput!
    $condition: ModelCustomerRequestItemsConditionInput
  ) {
    deleteCustomerRequestItems(input: $input, condition: $condition) {
      id
      createdAt
      companyID
      contactPersonID
      title
      description
      customerArticleNumber
      material
      itemsID
      notes
      customerRequestsID
      baseType
      updatedAt
    }
  }
`;
export const createSalesOffer = /* GraphQL */ `
  mutation CreateSalesOffer(
    $input: CreateSalesOfferInput!
    $condition: ModelSalesOfferConditionInput
  ) {
    createSalesOffer(input: $input, condition: $condition) {
      id
      customerRequestID
      acceptedByUserID
      createdAt
      companyID
      contactPersonID
      decimalPlaces
      number
      productRequestsID
      paymentConditions
      deliveryConditions
      deliveryTime
      itemsSelectable
      deliveryVat
      declineReason
      declineComment
      internalComment
      externalComment
      customerReference
      status
      validUntil
      sentExpiringReminder
      baseType
      sapDocNum
      sapDocEntry
      orderId
      acceptedAt
      acceptedChannel
      updatedAt
    }
  }
`;
export const updateSalesOffer = /* GraphQL */ `
  mutation UpdateSalesOffer(
    $input: UpdateSalesOfferInput!
    $condition: ModelSalesOfferConditionInput
  ) {
    updateSalesOffer(input: $input, condition: $condition) {
      id
      customerRequestID
      acceptedByUserID
      createdAt
      companyID
      contactPersonID
      decimalPlaces
      number
      productRequestsID
      paymentConditions
      deliveryConditions
      deliveryTime
      itemsSelectable
      deliveryVat
      declineReason
      declineComment
      internalComment
      externalComment
      customerReference
      status
      validUntil
      sentExpiringReminder
      baseType
      sapDocNum
      sapDocEntry
      orderId
      acceptedAt
      acceptedChannel
      updatedAt
    }
  }
`;
export const deleteSalesOffer = /* GraphQL */ `
  mutation DeleteSalesOffer(
    $input: DeleteSalesOfferInput!
    $condition: ModelSalesOfferConditionInput
  ) {
    deleteSalesOffer(input: $input, condition: $condition) {
      id
      customerRequestID
      acceptedByUserID
      createdAt
      companyID
      contactPersonID
      decimalPlaces
      number
      productRequestsID
      paymentConditions
      deliveryConditions
      deliveryTime
      itemsSelectable
      deliveryVat
      declineReason
      declineComment
      internalComment
      externalComment
      customerReference
      status
      validUntil
      sentExpiringReminder
      baseType
      sapDocNum
      sapDocEntry
      orderId
      acceptedAt
      acceptedChannel
      updatedAt
    }
  }
`;
export const createSalesOfferItems = /* GraphQL */ `
  mutation CreateSalesOfferItems(
    $input: CreateSalesOfferItemsInput!
    $condition: ModelSalesOfferItemsConditionInput
  ) {
    createSalesOfferItems(input: $input, condition: $condition) {
      id
      salesOffersID
      companyID
      createdAt
      title
      itemsID
      discount
      vat
      optional
      editable
      selected
      serviceTemplate
      number
      updatedAt
    }
  }
`;
export const updateSalesOfferItems = /* GraphQL */ `
  mutation UpdateSalesOfferItems(
    $input: UpdateSalesOfferItemsInput!
    $condition: ModelSalesOfferItemsConditionInput
  ) {
    updateSalesOfferItems(input: $input, condition: $condition) {
      id
      salesOffersID
      companyID
      createdAt
      title
      itemsID
      discount
      vat
      optional
      editable
      selected
      serviceTemplate
      number
      updatedAt
    }
  }
`;
export const deleteSalesOfferItems = /* GraphQL */ `
  mutation DeleteSalesOfferItems(
    $input: DeleteSalesOfferItemsInput!
    $condition: ModelSalesOfferItemsConditionInput
  ) {
    deleteSalesOfferItems(input: $input, condition: $condition) {
      id
      salesOffersID
      companyID
      createdAt
      title
      itemsID
      discount
      vat
      optional
      editable
      selected
      serviceTemplate
      number
      updatedAt
    }
  }
`;
export const createConsents = /* GraphQL */ `
  mutation CreateConsents(
    $input: CreateConsentsInput!
    $condition: ModelConsentsConditionInput
  ) {
    createConsents(input: $input, condition: $condition) {
      id
      objectID
      objectType
      consentType
      consentDefinitionID
      language
      channel
      accessLinkID
      userID
      contactPersonID
      email
      name
      companyID
      signerName
      emailVerifiedAt
      ipAddress
      userAgent
      createdAt
      objectSnapshot
      evidenceKey
      evidenceHash
      updatedAt
    }
  }
`;
export const createConsentDefinitions = /* GraphQL */ `
  mutation CreateConsentDefinitions(
    $input: CreateConsentDefinitionsInput!
    $condition: ModelConsentDefinitionsConditionInput
  ) {
    createConsentDefinitions(input: $input, condition: $condition) {
      id
      consentType
      version
      texts
      createdByUserId
      createdAt
      updatedAt
    }
  }
`;
export const createSalesOfferAccessLinks = /* GraphQL */ `
  mutation CreateSalesOfferAccessLinks(
    $input: CreateSalesOfferAccessLinksInput!
    $condition: ModelSalesOfferAccessLinksConditionInput
  ) {
    createSalesOfferAccessLinks(input: $input, condition: $condition) {
      id
      tokenHash
      salesOfferID
      createdAt
      recipientEmail
      recipientContactPersonID
      language
      expiresAt
      usedAt
      revoked
      createdByUserId
      codeHash
      codeExpiresAt
      codeAttempts
      codeSentAt
      accessCodeHash
      accessCodeAttempts
      updatedAt
    }
  }
`;
export const updateSalesOfferAccessLinks = /* GraphQL */ `
  mutation UpdateSalesOfferAccessLinks(
    $input: UpdateSalesOfferAccessLinksInput!
    $condition: ModelSalesOfferAccessLinksConditionInput
  ) {
    updateSalesOfferAccessLinks(input: $input, condition: $condition) {
      id
      tokenHash
      salesOfferID
      createdAt
      recipientEmail
      recipientContactPersonID
      language
      expiresAt
      usedAt
      revoked
      createdByUserId
      codeHash
      codeExpiresAt
      codeAttempts
      codeSentAt
      accessCodeHash
      accessCodeAttempts
      updatedAt
    }
  }
`;
export const createCommunicationMessages = /* GraphQL */ `
  mutation CreateCommunicationMessages(
    $input: CreateCommunicationMessagesInput!
    $condition: ModelCommunicationMessagesConditionInput
  ) {
    createCommunicationMessages(input: $input, condition: $condition) {
      id
      countries
      companyID
      userID
      contactPersonUserId
      objectID
      objectType
      createdAt
      updatedAt
      content
      editedAt
      broadcastID
      taskStatus
      quotedMessageID
      parentObjectID
    }
  }
`;
export const updateCommunicationMessages = /* GraphQL */ `
  mutation UpdateCommunicationMessages(
    $input: UpdateCommunicationMessagesInput!
    $condition: ModelCommunicationMessagesConditionInput
  ) {
    updateCommunicationMessages(input: $input, condition: $condition) {
      id
      countries
      companyID
      userID
      contactPersonUserId
      objectID
      objectType
      createdAt
      updatedAt
      content
      editedAt
      broadcastID
      taskStatus
      quotedMessageID
      parentObjectID
    }
  }
`;
export const deleteCommunicationMessages = /* GraphQL */ `
  mutation DeleteCommunicationMessages(
    $input: DeleteCommunicationMessagesInput!
    $condition: ModelCommunicationMessagesConditionInput
  ) {
    deleteCommunicationMessages(input: $input, condition: $condition) {
      id
      countries
      companyID
      userID
      contactPersonUserId
      objectID
      objectType
      createdAt
      updatedAt
      content
      editedAt
      broadcastID
      taskStatus
      quotedMessageID
      parentObjectID
    }
  }
`;
export const createHsCodes = /* GraphQL */ `
  mutation CreateHsCodes(
    $input: CreateHsCodesInput!
    $condition: ModelHsCodesConditionInput
  ) {
    createHsCodes(input: $input, condition: $condition) {
      id
      goodsCode
      goodsCodeCN
      duty
      createdAt
      updatedAt
    }
  }
`;
export const updateHsCodes = /* GraphQL */ `
  mutation UpdateHsCodes(
    $input: UpdateHsCodesInput!
    $condition: ModelHsCodesConditionInput
  ) {
    updateHsCodes(input: $input, condition: $condition) {
      id
      goodsCode
      goodsCodeCN
      duty
      createdAt
      updatedAt
    }
  }
`;
export const deleteHsCodes = /* GraphQL */ `
  mutation DeleteHsCodes(
    $input: DeleteHsCodesInput!
    $condition: ModelHsCodesConditionInput
  ) {
    deleteHsCodes(input: $input, condition: $condition) {
      id
      goodsCode
      goodsCodeCN
      duty
      createdAt
      updatedAt
    }
  }
`;
export const createQualityReports = /* GraphQL */ `
  mutation CreateQualityReports(
    $input: CreateQualityReportsInput!
    $condition: ModelQualityReportsConditionInput
  ) {
    createQualityReports(input: $input, condition: $condition) {
      id
      purchaseOrderItemsID
      countries
      maxQuantityItemsToCheck
      itemsID
      finalStatus
      finishedDate
      usedInstruments
      qualityReportTemplatesID
      createdAt
      updatedAt
      number
      baseType
    }
  }
`;
export const updateQualityReports = /* GraphQL */ `
  mutation UpdateQualityReports(
    $input: UpdateQualityReportsInput!
    $condition: ModelQualityReportsConditionInput
  ) {
    updateQualityReports(input: $input, condition: $condition) {
      id
      purchaseOrderItemsID
      countries
      maxQuantityItemsToCheck
      itemsID
      finalStatus
      finishedDate
      usedInstruments
      qualityReportTemplatesID
      createdAt
      updatedAt
      number
      baseType
    }
  }
`;
export const deleteQualityReports = /* GraphQL */ `
  mutation DeleteQualityReports(
    $input: DeleteQualityReportsInput!
    $condition: ModelQualityReportsConditionInput
  ) {
    deleteQualityReports(input: $input, condition: $condition) {
      id
      purchaseOrderItemsID
      countries
      maxQuantityItemsToCheck
      itemsID
      finalStatus
      finishedDate
      usedInstruments
      qualityReportTemplatesID
      createdAt
      updatedAt
      number
      baseType
    }
  }
`;
export const createQualityReportItems = /* GraphQL */ `
  mutation CreateQualityReportItems(
    $input: CreateQualityReportItemsInput!
    $condition: ModelQualityReportItemsConditionInput
  ) {
    createQualityReportItems(input: $input, condition: $condition) {
      id
      countries
      qualityReportID
      testedItems
      createdAt
      updatedAt
    }
  }
`;
export const updateQualityReportItems = /* GraphQL */ `
  mutation UpdateQualityReportItems(
    $input: UpdateQualityReportItemsInput!
    $condition: ModelQualityReportItemsConditionInput
  ) {
    updateQualityReportItems(input: $input, condition: $condition) {
      id
      countries
      qualityReportID
      testedItems
      createdAt
      updatedAt
    }
  }
`;
export const deleteQualityReportItems = /* GraphQL */ `
  mutation DeleteQualityReportItems(
    $input: DeleteQualityReportItemsInput!
    $condition: ModelQualityReportItemsConditionInput
  ) {
    deleteQualityReportItems(input: $input, condition: $condition) {
      id
      countries
      qualityReportID
      testedItems
      createdAt
      updatedAt
    }
  }
`;
export const createSupplierRequests = /* GraphQL */ `
  mutation CreateSupplierRequests(
    $input: CreateSupplierRequestsInput!
    $condition: ModelSupplierRequestsConditionInput
  ) {
    createSupplierRequests(input: $input, condition: $condition) {
      id
      positionNumber
      dueDate
      deliveryConditions
      currentSupplierRequestStatus
      countryCode
      companyID
      productRequestsID
      sentPriceMissingReminder
      totalReminders
      totalDueDateChanges
      createdAt
      updatedAt
    }
  }
`;
export const updateSupplierRequests = /* GraphQL */ `
  mutation UpdateSupplierRequests(
    $input: UpdateSupplierRequestsInput!
    $condition: ModelSupplierRequestsConditionInput
  ) {
    updateSupplierRequests(input: $input, condition: $condition) {
      id
      positionNumber
      dueDate
      deliveryConditions
      currentSupplierRequestStatus
      countryCode
      companyID
      productRequestsID
      sentPriceMissingReminder
      totalReminders
      totalDueDateChanges
      createdAt
      updatedAt
    }
  }
`;
export const deleteSupplierRequests = /* GraphQL */ `
  mutation DeleteSupplierRequests(
    $input: DeleteSupplierRequestsInput!
    $condition: ModelSupplierRequestsConditionInput
  ) {
    deleteSupplierRequests(input: $input, condition: $condition) {
      id
      positionNumber
      dueDate
      deliveryConditions
      currentSupplierRequestStatus
      countryCode
      companyID
      productRequestsID
      sentPriceMissingReminder
      totalReminders
      totalDueDateChanges
      createdAt
      updatedAt
    }
  }
`;
export const createSupplierRequestItems = /* GraphQL */ `
  mutation CreateSupplierRequestItems(
    $input: CreateSupplierRequestItemsInput!
    $condition: ModelSupplierRequestItemsConditionInput
  ) {
    createSupplierRequestItems(input: $input, condition: $condition) {
      id
      supplierRequestsID
      itemsID
      requestPriceOffersID
      priceOfferSubmitted
      companyID
      productRequestsItemsID
      productionTime
      categoryId
      countryCode
      currentSupplierRequestItemStatus
      declineReason
      declineComment
      reopened
      createdAt
      updatedAt
    }
  }
`;
export const updateSupplierRequestItems = /* GraphQL */ `
  mutation UpdateSupplierRequestItems(
    $input: UpdateSupplierRequestItemsInput!
    $condition: ModelSupplierRequestItemsConditionInput
  ) {
    updateSupplierRequestItems(input: $input, condition: $condition) {
      id
      supplierRequestsID
      itemsID
      requestPriceOffersID
      priceOfferSubmitted
      companyID
      productRequestsItemsID
      productionTime
      categoryId
      countryCode
      currentSupplierRequestItemStatus
      declineReason
      declineComment
      reopened
      createdAt
      updatedAt
    }
  }
`;
export const deleteSupplierRequestItems = /* GraphQL */ `
  mutation DeleteSupplierRequestItems(
    $input: DeleteSupplierRequestItemsInput!
    $condition: ModelSupplierRequestItemsConditionInput
  ) {
    deleteSupplierRequestItems(input: $input, condition: $condition) {
      id
      supplierRequestsID
      itemsID
      requestPriceOffersID
      priceOfferSubmitted
      companyID
      productRequestsItemsID
      productionTime
      categoryId
      countryCode
      currentSupplierRequestItemStatus
      declineReason
      declineComment
      reopened
      createdAt
      updatedAt
    }
  }
`;
export const createPayments = /* GraphQL */ `
  mutation CreatePayments(
    $input: CreatePaymentsInput!
    $condition: ModelPaymentsConditionInput
  ) {
    createPayments(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      paymentDate
      source
      status
      notes
      country
      companyID
      baseType
    }
  }
`;
export const updatePayments = /* GraphQL */ `
  mutation UpdatePayments(
    $input: UpdatePaymentsInput!
    $condition: ModelPaymentsConditionInput
  ) {
    updatePayments(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      paymentDate
      source
      status
      notes
      country
      companyID
      baseType
    }
  }
`;
export const deletePayments = /* GraphQL */ `
  mutation DeletePayments(
    $input: DeletePaymentsInput!
    $condition: ModelPaymentsConditionInput
  ) {
    deletePayments(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      paymentDate
      source
      status
      notes
      country
      companyID
      baseType
    }
  }
`;
export const createPaymentPurchaseOrderItems = /* GraphQL */ `
  mutation CreatePaymentPurchaseOrderItems(
    $input: CreatePaymentPurchaseOrderItemsInput!
    $condition: ModelPaymentPurchaseOrderItemsConditionInput
  ) {
    createPaymentPurchaseOrderItems(input: $input, condition: $condition) {
      id
      country
      paymentID
      purchaseOrderItemID
      claimID
      invoiceID
      createdAt
      updatedAt
    }
  }
`;
export const updatePaymentPurchaseOrderItems = /* GraphQL */ `
  mutation UpdatePaymentPurchaseOrderItems(
    $input: UpdatePaymentPurchaseOrderItemsInput!
    $condition: ModelPaymentPurchaseOrderItemsConditionInput
  ) {
    updatePaymentPurchaseOrderItems(input: $input, condition: $condition) {
      id
      country
      paymentID
      purchaseOrderItemID
      claimID
      invoiceID
      createdAt
      updatedAt
    }
  }
`;
export const deletePaymentPurchaseOrderItems = /* GraphQL */ `
  mutation DeletePaymentPurchaseOrderItems(
    $input: DeletePaymentPurchaseOrderItemsInput!
    $condition: ModelPaymentPurchaseOrderItemsConditionInput
  ) {
    deletePaymentPurchaseOrderItems(input: $input, condition: $condition) {
      id
      country
      paymentID
      purchaseOrderItemID
      claimID
      invoiceID
      createdAt
      updatedAt
    }
  }
`;
export const createClaims = /* GraphQL */ `
  mutation CreateClaims(
    $input: CreateClaimsInput!
    $condition: ModelClaimsConditionInput
  ) {
    createClaims(input: $input, condition: $condition) {
      id
      number
      status
      companyID
      supplierName
      notes
      country
      baseType
      createdAt
      updatedAt
    }
  }
`;
export const updateClaims = /* GraphQL */ `
  mutation UpdateClaims(
    $input: UpdateClaimsInput!
    $condition: ModelClaimsConditionInput
  ) {
    updateClaims(input: $input, condition: $condition) {
      id
      number
      status
      companyID
      supplierName
      notes
      country
      baseType
      createdAt
      updatedAt
    }
  }
`;
export const deleteClaims = /* GraphQL */ `
  mutation DeleteClaims(
    $input: DeleteClaimsInput!
    $condition: ModelClaimsConditionInput
  ) {
    deleteClaims(input: $input, condition: $condition) {
      id
      number
      status
      companyID
      supplierName
      notes
      country
      baseType
      createdAt
      updatedAt
    }
  }
`;
export const createClaimItems = /* GraphQL */ `
  mutation CreateClaimItems(
    $input: CreateClaimItemsInput!
    $condition: ModelClaimItemsConditionInput
  ) {
    createClaimItems(input: $input, condition: $condition) {
      id
      claimID
      purchaseOrderItemsID
      purchaseOrderID
      purchaseOrderNumber
      purchaseOrderItemTitle
      purchaseOrderItemNumber
      quantity
      orderedQuantity
      deliveredQuantity
      positions
      note
      claimStatus
      country
      baseType
      createdAt
      updatedAt
    }
  }
`;
export const updateClaimItems = /* GraphQL */ `
  mutation UpdateClaimItems(
    $input: UpdateClaimItemsInput!
    $condition: ModelClaimItemsConditionInput
  ) {
    updateClaimItems(input: $input, condition: $condition) {
      id
      claimID
      purchaseOrderItemsID
      purchaseOrderID
      purchaseOrderNumber
      purchaseOrderItemTitle
      purchaseOrderItemNumber
      quantity
      orderedQuantity
      deliveredQuantity
      positions
      note
      claimStatus
      country
      baseType
      createdAt
      updatedAt
    }
  }
`;
export const deleteClaimItems = /* GraphQL */ `
  mutation DeleteClaimItems(
    $input: DeleteClaimItemsInput!
    $condition: ModelClaimItemsConditionInput
  ) {
    deleteClaimItems(input: $input, condition: $condition) {
      id
      claimID
      purchaseOrderItemsID
      purchaseOrderID
      purchaseOrderNumber
      purchaseOrderItemTitle
      purchaseOrderItemNumber
      quantity
      orderedQuantity
      deliveredQuantity
      positions
      note
      claimStatus
      country
      baseType
      createdAt
      updatedAt
    }
  }
`;
export const createReclamations = /* GraphQL */ `
  mutation CreateReclamations(
    $input: CreateReclamationsInput!
    $condition: ModelReclamationsConditionInput
  ) {
    createReclamations(input: $input, condition: $condition) {
      id
      number
      status
      companyID
      supplierName
      notes
      country
      baseType
      createdAt
      updatedAt
    }
  }
`;
export const updateReclamations = /* GraphQL */ `
  mutation UpdateReclamations(
    $input: UpdateReclamationsInput!
    $condition: ModelReclamationsConditionInput
  ) {
    updateReclamations(input: $input, condition: $condition) {
      id
      number
      status
      companyID
      supplierName
      notes
      country
      baseType
      createdAt
      updatedAt
    }
  }
`;
export const deleteReclamations = /* GraphQL */ `
  mutation DeleteReclamations(
    $input: DeleteReclamationsInput!
    $condition: ModelReclamationsConditionInput
  ) {
    deleteReclamations(input: $input, condition: $condition) {
      id
      number
      status
      companyID
      supplierName
      notes
      country
      baseType
      createdAt
      updatedAt
    }
  }
`;
export const createReclamationItems = /* GraphQL */ `
  mutation CreateReclamationItems(
    $input: CreateReclamationItemsInput!
    $condition: ModelReclamationItemsConditionInput
  ) {
    createReclamationItems(input: $input, condition: $condition) {
      id
      reclamationID
      purchaseOrderItemsID
      purchaseOrderID
      purchaseOrderNumber
      purchaseOrderItemTitle
      purchaseOrderItemNumber
      quantity
      orderedQuantity
      deliveredQuantity
      positions
      note
      reclamationStatus
      country
      baseType
      createdAt
      updatedAt
    }
  }
`;
export const updateReclamationItems = /* GraphQL */ `
  mutation UpdateReclamationItems(
    $input: UpdateReclamationItemsInput!
    $condition: ModelReclamationItemsConditionInput
  ) {
    updateReclamationItems(input: $input, condition: $condition) {
      id
      reclamationID
      purchaseOrderItemsID
      purchaseOrderID
      purchaseOrderNumber
      purchaseOrderItemTitle
      purchaseOrderItemNumber
      quantity
      orderedQuantity
      deliveredQuantity
      positions
      note
      reclamationStatus
      country
      baseType
      createdAt
      updatedAt
    }
  }
`;
export const deleteReclamationItems = /* GraphQL */ `
  mutation DeleteReclamationItems(
    $input: DeleteReclamationItemsInput!
    $condition: ModelReclamationItemsConditionInput
  ) {
    deleteReclamationItems(input: $input, condition: $condition) {
      id
      reclamationID
      purchaseOrderItemsID
      purchaseOrderID
      purchaseOrderNumber
      purchaseOrderItemTitle
      purchaseOrderItemNumber
      quantity
      orderedQuantity
      deliveredQuantity
      positions
      note
      reclamationStatus
      country
      baseType
      createdAt
      updatedAt
    }
  }
`;
export const createLoadCalculation = /* GraphQL */ `
  mutation CreateLoadCalculation(
    $input: CreateLoadCalculationInput!
    $condition: ModelLoadCalculationConditionInput
  ) {
    createLoadCalculation(input: $input, condition: $condition) {
      id
      userId
      companyId
      name
      status
      inputPayload
      result
      resultS3Key
      errorMessage
      createdAt
      updatedAt
    }
  }
`;
export const updateLoadCalculation = /* GraphQL */ `
  mutation UpdateLoadCalculation(
    $input: UpdateLoadCalculationInput!
    $condition: ModelLoadCalculationConditionInput
  ) {
    updateLoadCalculation(input: $input, condition: $condition) {
      id
      userId
      companyId
      name
      status
      inputPayload
      result
      resultS3Key
      errorMessage
      createdAt
      updatedAt
    }
  }
`;
export const deleteLoadCalculation = /* GraphQL */ `
  mutation DeleteLoadCalculation(
    $input: DeleteLoadCalculationInput!
    $condition: ModelLoadCalculationConditionInput
  ) {
    deleteLoadCalculation(input: $input, condition: $condition) {
      id
      userId
      companyId
      name
      status
      inputPayload
      result
      resultS3Key
      errorMessage
      createdAt
      updatedAt
    }
  }
`;
export const createPaymentShipments = /* GraphQL */ `
  mutation CreatePaymentShipments(
    $input: CreatePaymentShipmentsInput!
    $condition: ModelPaymentShipmentsConditionInput
  ) {
    createPaymentShipments(input: $input, condition: $condition) {
      id
      country
      paymentID
      shipmentsID
      invoiceID
      createdAt
      updatedAt
    }
  }
`;
export const updatePaymentShipments = /* GraphQL */ `
  mutation UpdatePaymentShipments(
    $input: UpdatePaymentShipmentsInput!
    $condition: ModelPaymentShipmentsConditionInput
  ) {
    updatePaymentShipments(input: $input, condition: $condition) {
      id
      country
      paymentID
      shipmentsID
      invoiceID
      createdAt
      updatedAt
    }
  }
`;
export const deletePaymentShipments = /* GraphQL */ `
  mutation DeletePaymentShipments(
    $input: DeletePaymentShipmentsInput!
    $condition: ModelPaymentShipmentsConditionInput
  ) {
    deletePaymentShipments(input: $input, condition: $condition) {
      id
      country
      paymentID
      shipmentsID
      invoiceID
      createdAt
      updatedAt
    }
  }
`;
export const createInvoices = /* GraphQL */ `
  mutation CreateInvoices(
    $input: CreateInvoicesInput!
    $condition: ModelInvoicesConditionInput
  ) {
    createInvoices(input: $input, condition: $condition) {
      id
      number
      numberSearch
      date
      country
      companyID
      baseType
      createdAt
      updatedAt
    }
  }
`;
export const updateInvoices = /* GraphQL */ `
  mutation UpdateInvoices(
    $input: UpdateInvoicesInput!
    $condition: ModelInvoicesConditionInput
  ) {
    updateInvoices(input: $input, condition: $condition) {
      id
      number
      numberSearch
      date
      country
      companyID
      baseType
      createdAt
      updatedAt
    }
  }
`;
export const deleteInvoices = /* GraphQL */ `
  mutation DeleteInvoices(
    $input: DeleteInvoicesInput!
    $condition: ModelInvoicesConditionInput
  ) {
    deleteInvoices(input: $input, condition: $condition) {
      id
      number
      numberSearch
      date
      country
      companyID
      baseType
      createdAt
      updatedAt
    }
  }
`;
export const createErrorLog = /* GraphQL */ `
  mutation CreateErrorLog(
    $input: CreateErrorLogInput!
    $condition: ModelErrorLogConditionInput
  ) {
    createErrorLog(input: $input, condition: $condition) {
      id
      userId
      errorMessage
      errorStack
      url
      componentName
      critical
      baseType
      createdAt
      updatedAt
    }
  }
`;
export const updateErrorLog = /* GraphQL */ `
  mutation UpdateErrorLog(
    $input: UpdateErrorLogInput!
    $condition: ModelErrorLogConditionInput
  ) {
    updateErrorLog(input: $input, condition: $condition) {
      id
      userId
      errorMessage
      errorStack
      url
      componentName
      critical
      baseType
      createdAt
      updatedAt
    }
  }
`;
export const deleteErrorLog = /* GraphQL */ `
  mutation DeleteErrorLog(
    $input: DeleteErrorLogInput!
    $condition: ModelErrorLogConditionInput
  ) {
    deleteErrorLog(input: $input, condition: $condition) {
      id
      userId
      errorMessage
      errorStack
      url
      componentName
      critical
      baseType
      createdAt
      updatedAt
    }
  }
`;
export const createChecklist = /* GraphQL */ `
  mutation CreateChecklist(
    $input: CreateChecklistInput!
    $condition: ModelChecklistConditionInput
  ) {
    createChecklist(input: $input, condition: $condition) {
      id
      objectID
      objectType
      generatedChecklist
      checklistState
      generatingStatus
      baseType
      requestedByUserId
      createdAt
      updatedAt
    }
  }
`;
export const updateChecklist = /* GraphQL */ `
  mutation UpdateChecklist(
    $input: UpdateChecklistInput!
    $condition: ModelChecklistConditionInput
  ) {
    updateChecklist(input: $input, condition: $condition) {
      id
      objectID
      objectType
      generatedChecklist
      checklistState
      generatingStatus
      baseType
      requestedByUserId
      createdAt
      updatedAt
    }
  }
`;
export const deleteChecklist = /* GraphQL */ `
  mutation DeleteChecklist(
    $input: DeleteChecklistInput!
    $condition: ModelChecklistConditionInput
  ) {
    deleteChecklist(input: $input, condition: $condition) {
      id
      objectID
      objectType
      generatedChecklist
      checklistState
      generatingStatus
      baseType
      requestedByUserId
      createdAt
      updatedAt
    }
  }
`;
export const createTasks = /* GraphQL */ `
  mutation CreateTasks(
    $input: CreateTasksInput!
    $condition: ModelTasksConditionInput
  ) {
    createTasks(input: $input, condition: $condition) {
      id
      createdAt
      subject
      body
      taskType
      status
      priority
      dueDate
      completedAt
      assigneeType
      assignedUserId
      createdByUserId
      agentConfig
      companyID
      contactPersonId
      objectID
      objectType
      associatedObjectIds
      associatedObjects
      activityIDs
      originActivityID
      reminderMinutesBefore
      reminderSentAt
      hubspotRaw
      hubspotTaskId
      updatedAt
    }
  }
`;
export const updateTasks = /* GraphQL */ `
  mutation UpdateTasks(
    $input: UpdateTasksInput!
    $condition: ModelTasksConditionInput
  ) {
    updateTasks(input: $input, condition: $condition) {
      id
      createdAt
      subject
      body
      taskType
      status
      priority
      dueDate
      completedAt
      assigneeType
      assignedUserId
      createdByUserId
      agentConfig
      companyID
      contactPersonId
      objectID
      objectType
      associatedObjectIds
      associatedObjects
      activityIDs
      originActivityID
      reminderMinutesBefore
      reminderSentAt
      hubspotRaw
      hubspotTaskId
      updatedAt
    }
  }
`;
export const deleteTasks = /* GraphQL */ `
  mutation DeleteTasks(
    $input: DeleteTasksInput!
    $condition: ModelTasksConditionInput
  ) {
    deleteTasks(input: $input, condition: $condition) {
      id
      createdAt
      subject
      body
      taskType
      status
      priority
      dueDate
      completedAt
      assigneeType
      assignedUserId
      createdByUserId
      agentConfig
      companyID
      contactPersonId
      objectID
      objectType
      associatedObjectIds
      associatedObjects
      activityIDs
      originActivityID
      reminderMinutesBefore
      reminderSentAt
      hubspotRaw
      hubspotTaskId
      updatedAt
    }
  }
`;
export const createPushSubscriptions = /* GraphQL */ `
  mutation CreatePushSubscriptions(
    $input: CreatePushSubscriptionsInput!
    $condition: ModelPushSubscriptionsConditionInput
  ) {
    createPushSubscriptions(input: $input, condition: $condition) {
      id
      userId
      endpoint
      p256dh
      auth
      expirationTime
      createdAt
      updatedAt
    }
  }
`;
export const updatePushSubscriptions = /* GraphQL */ `
  mutation UpdatePushSubscriptions(
    $input: UpdatePushSubscriptionsInput!
    $condition: ModelPushSubscriptionsConditionInput
  ) {
    updatePushSubscriptions(input: $input, condition: $condition) {
      id
      userId
      endpoint
      p256dh
      auth
      expirationTime
      createdAt
      updatedAt
    }
  }
`;
export const deletePushSubscriptions = /* GraphQL */ `
  mutation DeletePushSubscriptions(
    $input: DeletePushSubscriptionsInput!
    $condition: ModelPushSubscriptionsConditionInput
  ) {
    deletePushSubscriptions(input: $input, condition: $condition) {
      id
      userId
      endpoint
      p256dh
      auth
      expirationTime
      createdAt
      updatedAt
    }
  }
`;
export const createMeasuringInstruments = /* GraphQL */ `
  mutation CreateMeasuringInstruments(
    $input: CreateMeasuringInstrumentsInput!
    $condition: ModelMeasuringInstrumentsConditionInput
  ) {
    createMeasuringInstruments(input: $input, condition: $condition) {
      id
      number
      name
      serialNumber
      location
      manufacturer
      manufacturerNumber
      calibratedAt
      calibratedUntil
      active
      baseType
      createdAt
      updatedAt
    }
  }
`;
export const updateMeasuringInstruments = /* GraphQL */ `
  mutation UpdateMeasuringInstruments(
    $input: UpdateMeasuringInstrumentsInput!
    $condition: ModelMeasuringInstrumentsConditionInput
  ) {
    updateMeasuringInstruments(input: $input, condition: $condition) {
      id
      number
      name
      serialNumber
      location
      manufacturer
      manufacturerNumber
      calibratedAt
      calibratedUntil
      active
      baseType
      createdAt
      updatedAt
    }
  }
`;
export const deleteMeasuringInstruments = /* GraphQL */ `
  mutation DeleteMeasuringInstruments(
    $input: DeleteMeasuringInstrumentsInput!
    $condition: ModelMeasuringInstrumentsConditionInput
  ) {
    deleteMeasuringInstruments(input: $input, condition: $condition) {
      id
      number
      name
      serialNumber
      location
      manufacturer
      manufacturerNumber
      calibratedAt
      calibratedUntil
      active
      baseType
      createdAt
      updatedAt
    }
  }
`;
export const createEmails = /* GraphQL */ `
  mutation CreateEmails(
    $input: CreateEmailsInput!
    $condition: ModelEmailsConditionInput
  ) {
    createEmails(input: $input, condition: $condition) {
      id
      internetMessageId
      conversationId
      graphMessageId
      mailboxUpn
      direction
      subject
      fromEmail
      fromName
      toEmails
      ccEmails
      bodyText
      bodyPreview
      hasAttachments
      receivedAt
      companyID
      contactPersonID
      userId
      hubspotEmailId
      baseType
      webLink
      linkSource
      hubspotRaw
      taskID
      attachments
      deletedAt
      companyOwnerUserId
      leadShare
      createdAt
      updatedAt
    }
  }
`;
export const updateEmails = /* GraphQL */ `
  mutation UpdateEmails(
    $input: UpdateEmailsInput!
    $condition: ModelEmailsConditionInput
  ) {
    updateEmails(input: $input, condition: $condition) {
      id
      internetMessageId
      conversationId
      graphMessageId
      mailboxUpn
      direction
      subject
      fromEmail
      fromName
      toEmails
      ccEmails
      bodyText
      bodyPreview
      hasAttachments
      receivedAt
      companyID
      contactPersonID
      userId
      hubspotEmailId
      baseType
      webLink
      linkSource
      hubspotRaw
      taskID
      attachments
      deletedAt
      companyOwnerUserId
      leadShare
      createdAt
      updatedAt
    }
  }
`;
export const deleteEmails = /* GraphQL */ `
  mutation DeleteEmails(
    $input: DeleteEmailsInput!
    $condition: ModelEmailsConditionInput
  ) {
    deleteEmails(input: $input, condition: $condition) {
      id
      internetMessageId
      conversationId
      graphMessageId
      mailboxUpn
      direction
      subject
      fromEmail
      fromName
      toEmails
      ccEmails
      bodyText
      bodyPreview
      hasAttachments
      receivedAt
      companyID
      contactPersonID
      userId
      hubspotEmailId
      baseType
      webLink
      linkSource
      hubspotRaw
      taskID
      attachments
      deletedAt
      companyOwnerUserId
      leadShare
      createdAt
      updatedAt
    }
  }
`;
export const createEmailLinks = /* GraphQL */ `
  mutation CreateEmailLinks(
    $input: CreateEmailLinksInput!
    $condition: ModelEmailLinksConditionInput
  ) {
    createEmailLinks(input: $input, condition: $condition) {
      id
      emailID
      objectID
      objectType
      receivedAt
      createdAt
      updatedAt
    }
  }
`;
export const updateEmailLinks = /* GraphQL */ `
  mutation UpdateEmailLinks(
    $input: UpdateEmailLinksInput!
    $condition: ModelEmailLinksConditionInput
  ) {
    updateEmailLinks(input: $input, condition: $condition) {
      id
      emailID
      objectID
      objectType
      receivedAt
      createdAt
      updatedAt
    }
  }
`;
export const deleteEmailLinks = /* GraphQL */ `
  mutation DeleteEmailLinks(
    $input: DeleteEmailLinksInput!
    $condition: ModelEmailLinksConditionInput
  ) {
    deleteEmailLinks(input: $input, condition: $condition) {
      id
      emailID
      objectID
      objectType
      receivedAt
      createdAt
      updatedAt
    }
  }
`;
export const createEmailSyncState = /* GraphQL */ `
  mutation CreateEmailSyncState(
    $input: CreateEmailSyncStateInput!
    $condition: ModelEmailSyncStateConditionInput
  ) {
    createEmailSyncState(input: $input, condition: $condition) {
      id
      mailboxUpn
      folder
      deltaLink
      lastRunAt
      lastError
      failedMessages
      createdAt
      updatedAt
    }
  }
`;
export const updateEmailSyncState = /* GraphQL */ `
  mutation UpdateEmailSyncState(
    $input: UpdateEmailSyncStateInput!
    $condition: ModelEmailSyncStateConditionInput
  ) {
    updateEmailSyncState(input: $input, condition: $condition) {
      id
      mailboxUpn
      folder
      deltaLink
      lastRunAt
      lastError
      failedMessages
      createdAt
      updatedAt
    }
  }
`;
export const deleteEmailSyncState = /* GraphQL */ `
  mutation DeleteEmailSyncState(
    $input: DeleteEmailSyncStateInput!
    $condition: ModelEmailSyncStateConditionInput
  ) {
    deleteEmailSyncState(input: $input, condition: $condition) {
      id
      mailboxUpn
      folder
      deltaLink
      lastRunAt
      lastError
      failedMessages
      createdAt
      updatedAt
    }
  }
`;
export const createActivities = /* GraphQL */ `
  mutation CreateActivities(
    $input: CreateActivitiesInput!
    $condition: ModelActivitiesConditionInput
  ) {
    createActivities(input: $input, condition: $condition) {
      id
      activityType
      subject
      body
      occurredAt
      companyID
      contactPersonId
      userId
      objectID
      objectType
      taskID
      direction
      durationSeconds
      outcome
      phoneNumber
      endsAt
      location
      companyOwnerUserId
      leadShare
      hubspotActivityId
      hubspotRaw
      createdAt
      updatedAt
    }
  }
`;
export const updateActivities = /* GraphQL */ `
  mutation UpdateActivities(
    $input: UpdateActivitiesInput!
    $condition: ModelActivitiesConditionInput
  ) {
    updateActivities(input: $input, condition: $condition) {
      id
      activityType
      subject
      body
      occurredAt
      companyID
      contactPersonId
      userId
      objectID
      objectType
      taskID
      direction
      durationSeconds
      outcome
      phoneNumber
      endsAt
      location
      companyOwnerUserId
      leadShare
      hubspotActivityId
      hubspotRaw
      createdAt
      updatedAt
    }
  }
`;
export const deleteActivities = /* GraphQL */ `
  mutation DeleteActivities(
    $input: DeleteActivitiesInput!
    $condition: ModelActivitiesConditionInput
  ) {
    deleteActivities(input: $input, condition: $condition) {
      id
      activityType
      subject
      body
      occurredAt
      companyID
      contactPersonId
      userId
      objectID
      objectType
      taskID
      direction
      durationSeconds
      outcome
      phoneNumber
      endsAt
      location
      companyOwnerUserId
      leadShare
      hubspotActivityId
      hubspotRaw
      createdAt
      updatedAt
    }
  }
`;
export const createEmailTrackingBlocklist = /* GraphQL */ `
  mutation CreateEmailTrackingBlocklist(
    $input: CreateEmailTrackingBlocklistInput!
    $condition: ModelEmailTrackingBlocklistConditionInput
  ) {
    createEmailTrackingBlocklist(input: $input, condition: $condition) {
      id
      createdBy
      sharedBase
      sharedGroups
      adminGroups
      patternType
      pattern
      note
      createdAt
      updatedAt
    }
  }
`;
export const createDemandInputs = /* GraphQL */ `
  mutation CreateDemandInputs(
    $input: CreateDemandInputsInput!
    $condition: ModelDemandInputsConditionInput
  ) {
    createDemandInputs(input: $input, condition: $condition) {
      id
      companyId
      itemNumber
      stockQuantity
      stockDate
      plannedOrderDate
      plannedQuantity
      neededByDate
      note
      sourceActivityId
      suppressUntil
      suppressReason
      recordedAt
      createdByUserId
      createdAt
      updatedAt
    }
  }
`;
export const updateDemandInputs = /* GraphQL */ `
  mutation UpdateDemandInputs(
    $input: UpdateDemandInputsInput!
    $condition: ModelDemandInputsConditionInput
  ) {
    updateDemandInputs(input: $input, condition: $condition) {
      id
      companyId
      itemNumber
      stockQuantity
      stockDate
      plannedOrderDate
      plannedQuantity
      neededByDate
      note
      sourceActivityId
      suppressUntil
      suppressReason
      recordedAt
      createdByUserId
      createdAt
      updatedAt
    }
  }
`;
export const deleteDemandInputs = /* GraphQL */ `
  mutation DeleteDemandInputs(
    $input: DeleteDemandInputsInput!
    $condition: ModelDemandInputsConditionInput
  ) {
    deleteDemandInputs(input: $input, condition: $condition) {
      id
      companyId
      itemNumber
      stockQuantity
      stockDate
      plannedOrderDate
      plannedQuantity
      neededByDate
      note
      sourceActivityId
      suppressUntil
      suppressReason
      recordedAt
      createdByUserId
      createdAt
      updatedAt
    }
  }
`;
export const createCompaniesProductRequests = /* GraphQL */ `
  mutation CreateCompaniesProductRequests(
    $input: CreateCompaniesProductRequestsInput!
    $condition: ModelCompaniesProductRequestsConditionInput
  ) {
    createCompaniesProductRequests(input: $input, condition: $condition) {
      id
      companiesID
      productRequestsID
      createdAt
      updatedAt
      contactPersonUserId
      countryCode
      involvedUsersIds
      countries
    }
  }
`;
export const updateCompaniesProductRequests = /* GraphQL */ `
  mutation UpdateCompaniesProductRequests(
    $input: UpdateCompaniesProductRequestsInput!
    $condition: ModelCompaniesProductRequestsConditionInput
  ) {
    updateCompaniesProductRequests(input: $input, condition: $condition) {
      id
      companiesID
      productRequestsID
      createdAt
      updatedAt
      contactPersonUserId
      countryCode
      involvedUsersIds
      countries
    }
  }
`;
export const deleteCompaniesProductRequests = /* GraphQL */ `
  mutation DeleteCompaniesProductRequests(
    $input: DeleteCompaniesProductRequestsInput!
    $condition: ModelCompaniesProductRequestsConditionInput
  ) {
    deleteCompaniesProductRequests(input: $input, condition: $condition) {
      id
      companiesID
      productRequestsID
      createdAt
      updatedAt
      contactPersonUserId
      countryCode
      involvedUsersIds
      countries
    }
  }
`;
export const customCreateInvitations = /* GraphQL */ `
  mutation CustomCreateInvitations($input: CustomCreateInvitationsInput!) {
    customCreateInvitations(input: $input) {
      id
      companyId
      createdAt
      email
      invitedByUserId
      invitedByUserName
      invitedByUserEmail
      language
      roleId
      countryCode
      reminderStatus
      ttl
      updatedAt
    }
  }
`;
export const customUpdateInvitations = /* GraphQL */ `
  mutation CustomUpdateInvitations($input: CustomUpdateInvitationsInput!) {
    customUpdateInvitations(input: $input) {
      id
      companyId
      createdAt
      email
      invitedByUserId
      invitedByUserName
      invitedByUserEmail
      language
      roleId
      countryCode
      reminderStatus
      ttl
      updatedAt
    }
  }
`;
export const customDeleteInvitations = /* GraphQL */ `
  mutation CustomDeleteInvitations($input: CustomDeleteInvitationsInput!) {
    customDeleteInvitations(input: $input) {
      id
      companyId
      createdAt
      email
      invitedByUserId
      invitedByUserName
      invitedByUserEmail
      language
      roleId
      countryCode
      reminderStatus
      ttl
      updatedAt
    }
  }
`;
export const customChangeUserRole = /* GraphQL */ `
  mutation CustomChangeUserRole($input: CustomChangeUserRoleInput!) {
    customChangeUserRole(input: $input) {
      id
    }
  }
`;
export const customResetUserMfa = /* GraphQL */ `
  mutation CustomResetUserMfa($input: CustomResetUserMfaInput!) {
    customResetUserMfa(input: $input) {
      id
      companyId
      companyContactPersonUserId
      country
      contactPersonUserId
      email
      baseType
      imageUrl
      lastLogin
      firstName
      lastName
      language
      mobil
      phone
      position
      pushNotifications
      notifications
      forms
      productTourStatus
      roleId
      settings
      twoFactorEnabled
      createdAt
      updatedAt
      countryCode
    }
  }
`;
export const customAcceptSalesOffer = /* GraphQL */ `
  mutation CustomAcceptSalesOffer($input: CustomAcceptSalesOfferInput!) {
    customAcceptSalesOffer(input: $input) {
      id
      customerRequestID
      acceptedByUserID
      createdAt
      companyID
      contactPersonID
      decimalPlaces
      number
      productRequestsID
      paymentConditions
      deliveryConditions
      deliveryTime
      itemsSelectable
      deliveryVat
      declineReason
      declineComment
      internalComment
      externalComment
      customerReference
      status
      validUntil
      sentExpiringReminder
      baseType
      sapDocNum
      sapDocEntry
      orderId
      acceptedAt
      acceptedChannel
      updatedAt
    }
  }
`;
export const customDeclineSalesOffer = /* GraphQL */ `
  mutation CustomDeclineSalesOffer($input: CustomDeclineSalesOfferInput!) {
    customDeclineSalesOffer(input: $input) {
      id
      customerRequestID
      acceptedByUserID
      createdAt
      companyID
      contactPersonID
      decimalPlaces
      number
      productRequestsID
      paymentConditions
      deliveryConditions
      deliveryTime
      itemsSelectable
      deliveryVat
      declineReason
      declineComment
      internalComment
      externalComment
      customerReference
      status
      validUntil
      sentExpiringReminder
      baseType
      sapDocNum
      sapDocEntry
      orderId
      acceptedAt
      acceptedChannel
      updatedAt
    }
  }
`;
export const customSendSalesOfferAccessLink = /* GraphQL */ `
  mutation CustomSendSalesOfferAccessLink(
    $input: CustomSendSalesOfferAccessLinkInput!
  ) {
    customSendSalesOfferAccessLink(input: $input) {
      url
      accessCode
    }
  }
`;
export const customRevokeSalesOfferAccessLink = /* GraphQL */ `
  mutation CustomRevokeSalesOfferAccessLink(
    $input: CustomRevokeSalesOfferAccessLinkInput!
  ) {
    customRevokeSalesOfferAccessLink(input: $input) {
      id
      tokenHash
      salesOfferID
      createdAt
      recipientEmail
      recipientContactPersonID
      language
      expiresAt
      usedAt
      revoked
      createdByUserId
      codeHash
      codeExpiresAt
      codeAttempts
      codeSentAt
      accessCodeHash
      accessCodeAttempts
      updatedAt
    }
  }
`;
export const customRemoveCustomerRequestDraft = /* GraphQL */ `
  mutation CustomRemoveCustomerRequestDraft(
    $input: CustomRemoveCustomerRequestDraftInput!
  ) {
    customRemoveCustomerRequestDraft(input: $input) {
      id
      createdAt
      currentStatus
      deliveryDate
      deliveryConditions
      number
      contactPersonID
      customerContactPersonID
      notes
      companyID
      reference
      successfull
      hubspotDealId
      productRequestsID
      baseType
      updatedAt
    }
  }
`;
export const customRemoveCustomerRequestItems = /* GraphQL */ `
  mutation CustomRemoveCustomerRequestItems(
    $input: CustomRemoveCustomerRequestItemsInput!
  ) {
    customRemoveCustomerRequestItems(input: $input) {
      id
      createdAt
      currentStatus
      deliveryDate
      deliveryConditions
      number
      contactPersonID
      customerContactPersonID
      notes
      companyID
      reference
      successfull
      hubspotDealId
      productRequestsID
      baseType
      updatedAt
    }
  }
`;
export const customRemoveUser = /* GraphQL */ `
  mutation CustomRemoveUser($input: CustomRemoveUserInput!) {
    customRemoveUser(input: $input) {
      id
    }
  }
`;
export const customDeleteContactPerson = /* GraphQL */ `
  mutation CustomDeleteContactPerson($input: CustomDeleteContactPersonInput!) {
    customDeleteContactPerson(input: $input) {
      id
      companyID
    }
  }
`;
export const customDeleteCompany = /* GraphQL */ `
  mutation CustomDeleteCompany($input: CustomDeleteCompanyInput!) {
    customDeleteCompany(input: $input) {
      id
      number
      name
      createdAt
      merge
    }
  }
`;
export const customUpdateProductRequestSquad = /* GraphQL */ `
  mutation CustomUpdateProductRequestSquad(
    $input: CustomUpdateProductRequestSquadInput!
  ) {
    customUpdateProductRequestSquad(input: $input)
  }
`;
export const customCreateCompany = /* GraphQL */ `
  mutation CustomCreateCompany($input: CustomCompanyInput!) {
    customCreateCompany(input: $input) {
      id
      number
      name
      createdAt
      merge
    }
  }
`;
export const customUpdateCompany = /* GraphQL */ `
  mutation CustomUpdateCompany($input: CustomCompanyInput!) {
    customUpdateCompany(input: $input) {
      id
      number
      name
      createdAt
      merge
    }
  }
`;
export const customCreateContactPerson = /* GraphQL */ `
  mutation CustomCreateContactPerson($input: CustomContactPersonInput!) {
    customCreateContactPerson(input: $input) {
      id
      companyID
    }
  }
`;
export const customUpdateContactPerson = /* GraphQL */ `
  mutation CustomUpdateContactPerson($input: CustomContactPersonInput!) {
    customUpdateContactPerson(input: $input) {
      id
      companyID
    }
  }
`;
